import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { personalizeAction } from "../../../store/pesonalize-store";
import validateInfo from "../validateInfo";
import useHttp from "../../../hooks/use-http";
import { endPoints } from "../../../config/end-points";
import {fonts} from "../../../config/webFontLists"
import {
  FaSortDown,
  FaSortUp,
  FaPlay,
  FaRegClock,
  FaPause,
  FaTimesCircle,
  FaPager,
} from "react-icons/fa";
import {RiPagesFill} from "react-icons/ri";
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi";
import { useRef } from "react";
import { cuteToast } from "../../UI/cute";
import Switch from "react-switch";
// import useVideoPlayer from "./useVideoPlayer";
import Slider from 'rc-slider';
// import "rc-slider/assets/index.css";
import {
  BsArrowRightSquare,
  BsCodeSlash,
  BsFillEmojiHeartEyesFill,
  BsQuestionCircle,
} from "react-icons/bs";
import { BiEditAlt } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { MdOutlineInsertEmoticon, MdRequestPage } from "react-icons/md"
// import { WidthProvider, Responsive } from "react-grid-layout";
import { Resizable } from "re-resizable";
import Draggable from 'react-draggable'; // The default
import Select from "react-select";
import Input from "../../UI/Input";
import ColorPicker from "../../UI/ColorPicker";
import OverlayTemplatesModal from "../../shared/modals/OverlayTemplatesModal";
import LowerThirdTemplatesModal from "../../shared/modals/LowerThirdTemplatesModal";
import { smiley } from "../../../config/icons";
import { settingAction } from "../../../store/setting-store";
// const ResponsiveReactGridLayout = WidthProvider(Responsive);
import ReactPlayer from 'react-player'
import UploadService from "../../../Services/FileUploadServices";
import WebFont from 'webfontloader';
import "../personalize.css";
import "../custAnimate.scss";
import "../animate.styles.css";

const VideoActions = ({useVideoPlayer,videoUrl,videoDuration,playerStatus}) => {
  const { sendRequest: fetchDataRequest } = useHttp();

  const [showMeetingLink, setShowMeetingLink] = useState(false);
  const [showCTA, setShowCTA] = useState(false);
  const [showAnnotation, setShowAnnotation] = useState(false);
  const [showCopyPaste, setShowCopyPaste] = useState(false);
  const [showLeadGenForm, setShowLeadGenForm] = useState(false);
  const [showCustomPoll, setShowCustomPoll] = useState(false);

  const [showOverlay, setShowOverlay] = useState(false);
  const [showEffectControls,setShowEffectControls] = useState(false);
  const [showLowerThird, setShowLowerThird] = useState(false);
  const [showTimingControl,setShowTimingControl] = useState(false);
  const [showActiveTrigger,setShowActiveTrigger] = useState("");
  const [isPlayInBetween,setIsPlayInBetween] = useState(false);

  const [showOverlayModal,setShowOverlayModal] = useState(false);
  const [showLowerThirdModal,setShowLowerThirdModal] = useState(false);

  const [showIcons,setShowIcons] = useState(false);
  const [activeElement,setActiveElelment] = useState("");

  const [isFontLoaded,setIsFontLoaded] = useState(false);

  const [errors, setErrors] = useState({});
  const { sendRequest: updatePersonalizeData } = useHttp();
  const { sendRequest: deletePersonalizeData } = useHttp();
  const { sendRequest: getConnetedResponderData } = useHttp();
  const { sendRequest: fetchResponderLists } = useHttp();

  const timeRef = useRef(null);
  const annoStartTimeRef = useRef(null);
  const annoEndtimeRef = useRef(null);
  const CRMstartTimeRef = useRef(null);
  const CRMendtimeRef = useRef(null);
  const leadgenTimeRef = useRef(null);
  const pollTimeRef = useRef(null);
  const startTimeRef = useRef(null)
  const endTimeRef = useRef(null)
  const setStartTimeRef = useRef(null)
  const setEndTimeRef = useRef(null)

  const dispatch = useDispatch();

  const videoLength = useSelector((state) => state.campaign.total_duration);
  const token = useSelector((state) => state.auth.token);

  const is_autoresponder_loaded = useSelector(
    (state) => state.settings.is_autoresponder_loaded
  );

  const myAccess = useSelector((state) => state.auth.access);

  const autoresponder = useSelector((state) => state.settings.autoresponder)
  const [activeCampaignLists,setActiveCampaignLists] = useState({})
  // console.log(autoresponder)

  useEffect(() => {
    // console.log(is_autoresponder_loaded);
    if (!is_autoresponder_loaded) {
      getConnetedResponderData(
        {
          url: endPoints.fetchAllKeys,
          method: "GET",
        },
        (response) => {
          dispatch(
            settingAction.setAutoresponder({ autoresponder: response.body })
          );

          dispatch(settingAction.setAutoresponderStatus({ status: true }));
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_autoresponder_loaded]);

  const personalize_triggerTime = useSelector(
    (state) => state.personalize.personalize_triggerTime
  );

  // const personalize_page_load = useSelector(
  //     (state) => state.personalize.personalize_page_load
  // );

  const [triggerTime, setTriggerTime] = useState(personalize_triggerTime);

  const videoElement = useRef();

  const {
    // playerState,
    // togglePlay,
    // handleOnTimeUpdate,
    // handleVideoProgress,
    // handleVideoSpeed,
    // toggleMute,
    // handleAudioLevel,
    handleVideoLength
  } = useVideoPlayer(videoElement);

  const { camp_id } = useParams();

  const campaign_data = useSelector((state) => state.campaign.campaign_data);
  const overlayData = useSelector((state) => state.personalize.personalize_overlayTemplateData);

  const [videoMeetingData, setVideoMeetingData] = useState({
    fullname: "John Smith",
    designation: "Senior Manager",
    buttontext: "Join Me",
    meetingLink: "https://calendly.me",
    buttonColor: "#00b2eb",
  });

  const [videoCTAData, setVideoCTAData] = useState({
    formtype: "text",
    text: "",
    image: "",
    link: "",
    actiontime: "00:00",
    ctaSkipCheck: true,
  });

  const [annotationData, setAnnotationData] = useState({
    annotationText: "Click on this link",
    annotationLink: "",
    annotationStartTime: "00:00",
    annotationEndTime: "00:00",
  });

  const [copyPasteData, setCopyPasteData] = useState({
    CRMHtmlText: "",
    CRMskipCheck: true,
    bgCRMTheme: true,
    CRMstartTime: "00:00",
    // CRMendTime: "00:00"
  });

  const [leadgenFormData, setLeadgenFormData] = useState({
    askphonechk: false,
    askcompanychk: false,
    headline: "Enter the following details to continue playing",
    buttonname: "Play",
    note: "Note",
    leadgenTime: "00:00",
    leadgenSkipCheck: true,
    responderType:"",
    param1:"",
    param2:"",
    param3:"",
  });

  const [custPollData, setCustPollData] = useState({
    question: "Your Question ?",
    option1: "Yes",
    option2: "No",
    option3: "",
    pollTime: "00:00",
    pollSkipChk: true,
  });

  const [width, setWidth] = useState(200);
  const [height, setHeight] = useState(100);

  const [showAnimation,setShowAnimation] = useState({
    name:null,
    text1:null,
    text2:null,
    startTime:"00:00",
    endTime:"00:00",
    xPosition:0,
    yPosition:0,
    text1FontSize:"",
    text2FontSize:"",
    text1FontFamily:"",
    text2FontFamily:"",
    text1FontColor:"",
    text2FontColor:"",
    text1BgColor:"",
    text2BgColor:"",
    width,
    height,
    bgTheme:"",
    nameAnim:null,
    textAnim1:null,
    textAnim2:null,
    simpleRevealShow:null,
    speechBubble:null,
    speechThought:null,
    speechBubble2:null,
    speechBubble3:null,
    borderAnim:null,
    borderAnim2:null,
    ltAnimation1:null,
    ltAnimation2:null,
    ltAnimation3:null,
    ltAnimation4:null,
    ltAnimation5:null,
    smiley:null,
    smileyContent:[],
    animationType:""
  })

  const handleChange = (layer_name, index, color) => setShowAnimation({...showAnimation,bgTheme:color});

  var options = fonts

  const [actionPoint, setActionPoint] = useState([]);

  const [pageLoad, setPageLoad] = useState(false);

  const [ytPlayer,setYtPlayer] = useState({
    url: "",
    playing: false,
    volume: 0.8,
    muted: false,
    played: 0,
    loaded: 0,
    duration: 0,
    playedSeconds:0,
    start:"00:00",
    end: 5
  })

  // const createSliderWithTooltip = Slider.createSliderWithTooltip;
  // const RangeSlider = createSliderWithTooltip(Slider.Range);
  // const Range = createSliderWithTooltip(Slider);

  const ytPlayerRef = useRef(null);
  const [showPreviewElem,setShowPreviewElem] = useState(false)

  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "dashed 2px #ddd",
    textAlign: "center"
    // background: "#f0f0f0"
  };

  // console.log(pageLoad);

  useEffect(() => {
    showMeetingLink &&
      dispatch(
        personalizeAction.setMeetingData({
          personalize_meetingData: videoMeetingData,
        })
      );
    showCTA &&
      dispatch(
        personalizeAction.setCTAData({ personalize_CTAData: videoCTAData })
      );
    showAnnotation &&
      dispatch(
        personalizeAction.setAnnotationData({
          personalize_AnnotationData: annotationData,
        })
      );
    showCopyPaste &&
      dispatch(
        personalizeAction.setCopyPasteData({
          personalize_copyPasteData: copyPasteData,
        })
      );
    showLeadGenForm &&
      dispatch(
        personalizeAction.setLeadgenFormData({
          personalize_leadgenFormData: leadgenFormData,
        })
      );
    showCustomPoll &&
      dispatch(
        personalizeAction.setPollData({ personalize_pollData: custPollData })
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    videoMeetingData,
    videoCTAData,
    annotationData,
    copyPasteData,
    leadgenFormData,
    custPollData,
  ]);

  useEffect(() => {
    // console.log(videoDuration,videoLength,campaign_data.video_path)
    if(videoLength > 0){
      handleVideoLength({
        length:videoLength,
        start:videoDuration.start,
        end:videoDuration.end,
        status:playerStatus
      })

      setYtPlayer({
        ...ytPlayer,
        url:videoUrl
      })
      setPageLoad(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoLength,videoDuration,playerStatus]);

  useEffect(() => {
    // console.log(videoLength,pageLoad);
    if (!pageLoad && videoLength > 0) {
      // console.log(camp_id)
      fetchDataRequest(
        {
          url: endPoints.getPersonalize + "/" + camp_id,
          method: "GET",
        },
        responsePersonalizeHandle
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataRequest, camp_id, videoLength]);

  useEffect(()=>{

    actionPoint.map((trigger)=>{
      // console.log(trigger.action_time)
      let duration = trigger.action_time.split(":")
      let sec = (parseInt(duration[0] * 60) + parseInt(duration[1]))
      // console.log(sec,(ytPlayer.duration * ytPlayer.played))
      if(Math.round(ytPlayer.duration * ytPlayer.played) === sec){
        let showTrigger = trigger.action_event;
        if(!showPreviewElem){
          showPreview(showTrigger)
          setShowActiveTrigger(showTrigger)
        }
      }else{
        setShowPreviewElem(false)
        // setShowActiveTrigger("")
        // hidePreview()
      }
      // console.log(sec)
      return true;
    })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[ytPlayer.playedSeconds])

  const showPreview = (trigger) => {
    // console.log(trigger)
      setShowMeetingLink(false);
      setShowCTA(false);
      setShowAnnotation(false);
      setShowCopyPaste(false);
      setShowLeadGenForm(false);
      setShowCustomPoll(false);
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(false)
      setShowTimingControl(false)
      setShowActiveTrigger(trigger)
  
      if(trigger === "video_meeting"){
        setShowMeetingLink(true);
      }

      if(trigger === "video_cta"){
        setShowCTA(true) 
      }

      if(trigger === "video_annotation"){
        setShowAnnotation(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(annotationData.annotationStartTime),
          end:getSeconds(annotationData.annotationEndTime)
        })
      }

      if(trigger === "video_copypaste"){
        setShowCopyPaste(true) 
      }

      if(trigger === "video_leadgen"){
        setShowLeadGenForm(true)
      }

      if(trigger === "video_custPoll"){
        setShowCustomPoll(true)
      }

      if(trigger === "simple_reveal"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let revealData = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Simple Reveal Text",
          text1:revealData[0].text1,
          text2:revealData[0].text2,
          simpleRevealShow:revealData[0].simpleRevealShow,
          startTime: revealData[0].startTime,
          endTime : revealData[0].endTime,
          xPosition : revealData[0].xPosition,
          yPosition : revealData[0].yPosition,
          text1FontFamily:revealData[0].text1FontFamily,
          text1FontSize:revealData[0].text1FontSize,
          text1FontColor:revealData[0].text1FontColor,
          text1BgColor:revealData[0].text1BgColor,
          text2FontFamily:revealData[0].text2FontFamily,
          text2FontSize:revealData[0].text2FontSize,
          text2FontColor:revealData[0].text2FontColor,
          text2BgColor:revealData[0].text2BgColor,
          width:revealData[0].width,
          height:revealData[0].height,
          bgTheme:revealData[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          speechBubble:false,
          speechBubble2:false,
          speechBubble3:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(revealData[0].width)
        setHeight(revealData[0].height)
        setShowTimingControl(true) 
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(revealData[0].startTime),
          end:getSeconds(revealData[0].endTime)
        })
      }

      if(trigger === "speech_bubble"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        // console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Speech Bubble",
          text1:data[0].text1,
          speechBubble:data[0].speechBubble,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          simpleRevealShow:false,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          speechBubble2:false,
          speechBubble3:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        
      }

      if(trigger === "speech_bubble_2"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Speech Bubble",
          text1:data[0].text1,
          text2:data[0].text2,
          speechBubble2:data[0].speechBubble2,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          simpleRevealShow:false,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          speechBubble:false,
          speechBubble3:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "speech_bubble_3"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Speech Bubble",
          text1:data[0].text1,
          speechBubble3:data[0].speechBubble3,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "speech_thought"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        // console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Speech Thought",
          text1:data[0].text1,
          speechThought:data[0].speechThought,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "border_animation"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Border Animation",
          text1:data[0].text1,
          borderAnim:data[0].borderAnim,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          text2BgColor:data[0].text2BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "border_animation_2"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Border Animation",
          text1:data[0].text1,
          borderAnim2:data[0].borderAnim2,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "lt_animation_1"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          text2:data[0].text2,
          ltAnimation1:data[0].ltAnimation1,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          bgTheme:data[0].bgTheme,
          text2BgColor:data[0].text2BgColor,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })
        
      }

      if(trigger === "lt_animation_2"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          text2:data[0].text2,
          ltAnimation2:data[0].ltAnimation2,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation3:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })
        
      }

      if(trigger === "lt_animation_3"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          text2:data[0].text2,
          ltAnimation3:data[0].ltAnimation3,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })
        
      }

      if(trigger === "lt_animation_4"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          ltAnimation4:data[0].ltAnimation4,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          bgTheme:data[0].bgTheme,
          text2BgColor:data[0].text2BgColor,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation5:false,
          smiley:false
        })
        
      }

      if(trigger === "lt_animation_5"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          text2:data[0].text2,
          ltAnimation5:data[0].ltAnimation5,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          text2BgColor:data[0].text2BgColor,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          smiley:false
        })
        
      }

      if(trigger === "name_animation"){ 
        // setShowOverlay(false)
        // setShowLowerThird(false)
        setShowEffectControls(true)
        // setShowIcons(false);
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Text Overlay",
          text1:data[0].text1,
          nameAnim:data[0].nameAnim,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          width:data[0].width,
          height:data[0].height,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "text_animation_1"){ 
        // setShowOverlay(false)
        // setShowLowerThird(false)
        setShowEffectControls(true)
        // setShowIcons(false);
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Simple Text Animation",
          text1:data[0].text1,
          textAnim1:data[0].textAnim1,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          width:data[0].width,
          height:data[0].height,
          nameAnim : false,
          textAnim2 : false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "text_animation_2"){ 
        // setShowOverlay(false)
        // setShowLowerThird(false)
        setShowEffectControls(true)
        // setShowIcons(false);
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        // console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Simple Text Animation",
          text1:data[0].text1,
          textAnim2:data[0].textAnim2,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          width:data[0].width,
          height:data[0].height,
          nameAnim : false,
          textAnim1 : false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "emoji_content"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        setShowEffectControls(true)
        setShowIcons(true);
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Smiley",
          text1:data[0].text1,
          smiley:data[0].smiley,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          width:data[0].width,
          height:data[0].height,
          smileyContent:data[0].smileyContent,
          nameAnim:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          ltAnimation5:false,
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
        
      }
      setYtPlayer({...ytPlayer,playing:false})
    
  }

  const responsePersonalizeHandle = (response) => {
    // console.log('here',response)
    // console.log(videoLength,'here')
    if (response.body) {
      // console.log(response.body,'outputData')
      dispatch(personalizeAction.resetState());
      const data = response.body;
      const meetingData = data.filter(
        (item) => item.meta_type === "video_meeting"
      );
      const ctaData = data.filter((item) => item.meta_type === "video_cta");
      const annotationData = data.filter(
        (item) => item.meta_type === "video_annotation"
      );
      const copypasteData = data.filter(
        (item) => item.meta_type === "video_copypaste"
      );
      const leadgenData = data.filter(
        (item) => item.meta_type === "video_leadgen"
      );
      const custPollData = data.filter(
        (item) => item.meta_type === "video_custPoll"
      );
      const brandingData = data.filter(
        (item) => item.meta_type === "video_branding"
      );
      const privacyData = data.filter(
        (item) => item.meta_type === "video_privacy"
      );

      const simpleRevealData = data.filter((item)=>item.meta_type === 'simple_reveal')
      const speechBubbleData = data.filter((item)=>item.meta_type === 'speech_bubble')
      const speechThoughtData = data.filter((item)=>item.meta_type === 'speech_thought')
      const speechBubble2Data = data.filter((item)=>item.meta_type === 'speech_bubble_2')
      const speechBubble3Data = data.filter((item)=>item.meta_type === 'speech_bubble_3')
      const speechBubble4Data = data.filter((item)=>item.meta_type === 'speech_bubble_4')
      const borderAnimationData = data.filter((item)=>item.meta_type === 'border_animation')
      const borderAnimation2Data = data.filter((item)=>item.meta_type === 'border_animation_2')
      const ltAnimation1Data = data.filter((item)=>item.meta_type === 'lt_animation_1')
      const ltAnimation2Data = data.filter((item)=>item.meta_type === 'lt_animation_2')
      const ltAnimation3Data = data.filter((item)=>item.meta_type === 'lt_animation_3')
      const ltAnimation4Data = data.filter((item)=>item.meta_type === 'lt_animation_4')
      const ltAnimation5Data = data.filter((item)=>item.meta_type === 'lt_animation_5')
      const nameAnimData = data.filter((item)=>item.meta_type === 'name_animation')
      const textAnim1Data = data.filter((item)=>item.meta_type === 'text_animation_1')
      const textAnim2Data = data.filter((item)=>item.meta_type === 'text_animation_2')
      const emojiContentData = data.filter((item)=>item.meta_type === 'emoji_content')

      // console.log(emojiContentData)

      let actionPointArr = [];
      var overlayArr = [];

      if (meetingData.length > 0) {
        let mins = Math.floor(videoLength / 60);
        let meetingDuration =
          (mins < 10 ? `0${mins}` : mins) +
          ":" +
          ("0" + Math.floor(videoLength % 60)).slice(-2);
        dispatch(
          personalizeAction.setMeetingData({
            personalize_meetingData: JSON.parse(meetingData[0].meta_data),
          })
        );
        setVideoMeetingData(JSON.parse(meetingData[0].meta_data));
        actionPointArr.push({
          action_event: "video_meeting",
          action_time: meetingDuration,
          id:meetingData[0].id
        });
        setTriggerTime([...triggerTime, meetingDuration]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: meetingDuration,
          })
        );
      }

      if (ctaData && ctaData.length > 0) {
        let actionTime = JSON.parse(ctaData[0].meta_data).actiontime;
        dispatch(
          personalizeAction.setCTAData({
            personalize_CTAData: JSON.parse(ctaData[0].meta_data),
          })
        );
        setTriggerTime([...triggerTime, actionTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: actionTime,
          })
        );
        setVideoCTAData(JSON.parse(ctaData[0].meta_data));
        actionPointArr.push({
          action_event: "video_cta",
          action_time: actionTime,
          id:ctaData[0].id
        });
      }

      if (annotationData.length > 0) {
        let getAnnotationData = JSON.parse(annotationData[0].meta_data);
        dispatch(
          personalizeAction.setAnnotationData({
            personalize_AnnotationData: getAnnotationData,
          })
        );
        setAnnotationData(getAnnotationData);
        actionPointArr.push({
          action_event: "video_annotation",
          action_time: getAnnotationData.annotationStartTime,
          action_end_time:getAnnotationData.annotationEndTime,
          id:annotationData[0].id
        });
        setTriggerTime([...triggerTime, getAnnotationData.annotationStartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getAnnotationData.annotationStartTime,
          })
        );
      }

      if (copypasteData.length > 0) {
        let getCopypasteData = JSON.parse(copypasteData[0].meta_data);
        dispatch(
          personalizeAction.setCopyPasteData({
            personalize_copyPasteData: getCopypasteData,
          })
        );
        setCopyPasteData(getCopypasteData);
        actionPointArr.push({
          action_event: "video_copypaste",
          action_time: getCopypasteData.CRMstartTime,
          id:copypasteData[0].id
        });
        setTriggerTime([...triggerTime, getCopypasteData.CRMstartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getCopypasteData.CRMstartTime,
          })
        );
      }

      if (leadgenData.length > 0) {
        let getLeadGenData = JSON.parse(leadgenData[0].meta_data);
        dispatch(
          personalizeAction.setLeadgenFormData({
            personalize_leadgenFormData: getLeadGenData,
          })
        );
        setLeadgenFormData(getLeadGenData);
        actionPointArr.push({
          action_event: "video_leadgen",
          action_time: getLeadGenData.leadgenTime,
          id:leadgenData[0].id
        });
        setTriggerTime([...triggerTime, getLeadGenData.leadgenTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getLeadGenData.leadgenTime,
          })
        );
      }

      if (custPollData.length > 0) {
        let getcustpollData = JSON.parse(custPollData[0].meta_data);
        dispatch(
          personalizeAction.setPollData({
            personalize_pollData: getcustpollData,
          })
        );
        setCustPollData(getcustpollData);
        actionPointArr.push({
          action_event: "video_custPoll",
          action_time: getcustpollData.pollTime,
          id:custPollData[0].id
        });
        setTriggerTime([...triggerTime, getcustpollData.pollTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getcustpollData.pollTime,
          })
        );
      }

      if (brandingData.length > 0) {
        let getbrandingData = JSON.parse(brandingData[0].meta_data);
        dispatch(
          personalizeAction.setBrandingData({
            personalize_brandingData: getbrandingData,
          })
        );
      }

      if(privacyData.length > 0){
        let getprivacyData = JSON.parse(privacyData[0].meta_data)
        dispatch(personalizeAction.setPrivacyData({ personalize_privacyData: getprivacyData }));
      }

      if (simpleRevealData && simpleRevealData.length > 0) {
        let getsimpleRevealData = JSON.parse(simpleRevealData[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getsimpleRevealData)
        setTriggerTime([...triggerTime, getsimpleRevealData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getsimpleRevealData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "simple_reveal",
          action_time: getsimpleRevealData.startTime,
          action_end_time:getsimpleRevealData.endTime,
          id:simpleRevealData[0].id
        });
      }

      if (speechBubbleData && speechBubbleData.length > 0) {
        let getspeechBubbleData = JSON.parse(speechBubbleData[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getspeechBubbleData)
        setTriggerTime([...triggerTime, getspeechBubbleData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechBubbleData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_bubble",
          action_time: getspeechBubbleData.startTime,
          action_end_time:getspeechBubbleData.endTime,
          id:speechBubbleData[0].id
        });
      }

      if (speechThoughtData && speechThoughtData.length > 0) {
        let getspeechThoughtData = JSON.parse(speechThoughtData[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, speechThoughtData)
        setTriggerTime([...triggerTime, getspeechThoughtData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechThoughtData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_thought",
          action_time: getspeechThoughtData.startTime,
          action_end_time:getspeechThoughtData.endTime,
          id:speechThoughtData[0].id
        });
      }

      if (speechBubble2Data && speechBubble2Data.length > 0) {
        let getspeechBubble2Data = JSON.parse(speechBubble2Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getspeechBubble2Data)
        setTriggerTime([...triggerTime, getspeechBubble2Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechBubble2Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_bubble_2",
          action_time: getspeechBubble2Data.startTime,
          action_end_time:getspeechBubble2Data.endTime,
          id:speechBubble2Data[0].id
        });
      }

      if (speechBubble3Data && speechBubble3Data.length > 0) {
        let getspeechBubble3Data = JSON.parse(speechBubble3Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getspeechBubble3Data)
        setTriggerTime([...triggerTime, getspeechBubble3Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechBubble3Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_bubble_3",
          action_time: getspeechBubble3Data.startTime,
          action_end_time:getspeechBubble3Data.endTime,
          id:speechBubble3Data[0].id
        });
      }

      if (speechBubble4Data && speechBubble4Data.length > 0) {
        let getspeechBubble4Data = JSON.parse(speechBubble4Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getspeechBubble4Data)
        setTriggerTime([...triggerTime, getspeechBubble4Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechBubble4Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_bubble_4",
          action_time: getspeechBubble4Data.startTime,
          action_end_time:getspeechBubble4Data.endTime,
          id:speechBubble4Data[0].id
        });
      }

      if (borderAnimationData && borderAnimationData.length > 0) {
        let getborderAnimationData = JSON.parse(borderAnimationData[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getborderAnimationData)
        setTriggerTime([...triggerTime, getborderAnimationData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getborderAnimationData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "border_animation",
          action_time: getborderAnimationData.startTime,
          action_end_time:getborderAnimationData.endTime,
          id:borderAnimationData[0].id
        });
      }

      if (borderAnimation2Data && borderAnimation2Data.length > 0) {
        let getborderAnimation2Data = JSON.parse(borderAnimation2Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getborderAnimation2Data)
        setTriggerTime([...triggerTime, getborderAnimation2Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getborderAnimation2Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "border_animation_2",
          action_time: getborderAnimation2Data.startTime,
          action_end_time:getborderAnimation2Data.endTime,
          id:borderAnimation2Data[0].id
        });
      }

      if (ltAnimation1Data && ltAnimation1Data.length > 0) {
        let getltAnimation1Data = JSON.parse(ltAnimation1Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation1Data)
        setTriggerTime([...triggerTime, getltAnimation1Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation1Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_1",
          action_time: getltAnimation1Data.startTime,
          action_end_time:getltAnimation1Data.endTime,
          id:ltAnimation1Data[0].id
        });
      }

      if (ltAnimation2Data && ltAnimation2Data.length > 0) {
        let getltAnimation2Data = JSON.parse(ltAnimation2Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation2Data)
        setTriggerTime([...triggerTime, getltAnimation2Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation2Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_2",
          action_time: getltAnimation2Data.startTime,
          action_end_time:getltAnimation2Data.endTime,
          id:ltAnimation2Data[0].id
        });
      }

      if (ltAnimation3Data && ltAnimation3Data.length > 0) {
        let getltAnimation3Data = JSON.parse(ltAnimation3Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation3Data)
        setTriggerTime([...triggerTime, getltAnimation3Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation3Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_3",
          action_time: getltAnimation3Data.startTime,
          action_end_time:getltAnimation3Data.endTime,
          id:ltAnimation3Data[0].id
        });
      }

      if (ltAnimation4Data && ltAnimation4Data.length > 0) {
        let getltAnimation4Data = JSON.parse(ltAnimation4Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation4Data)
        setTriggerTime([...triggerTime, getltAnimation4Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation4Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_4",
          action_time: getltAnimation4Data.startTime,
          action_end_time:getltAnimation4Data.endTime,
          id:ltAnimation4Data[0].id
        });
      }

      if (ltAnimation5Data && ltAnimation5Data.length > 0) {
        let getltAnimation5Data = JSON.parse(ltAnimation5Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation5Data)
        setTriggerTime([...triggerTime, getltAnimation5Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation5Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_5",
          action_time: getltAnimation5Data.startTime,
          action_end_time:getltAnimation5Data.endTime,
          id:ltAnimation5Data[0].id
        });
      }

      if(nameAnimData && nameAnimData.length > 0){
        let getnameAnimData = JSON.parse(nameAnimData[0].meta_data);
          overlayArr = [].concat(overlayArr, getnameAnimData)
        // console.log(newState)
        setTriggerTime([...triggerTime, getnameAnimData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getnameAnimData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "name_animation",
          action_time: getnameAnimData.startTime,
          action_end_time:getnameAnimData.endTime,
          id:nameAnimData[0].id
        });
      }

      if(textAnim1Data && textAnim1Data.length > 0){
        let gettextAnim1Data = JSON.parse(textAnim1Data[0].meta_data);
          overlayArr = [].concat(overlayArr, gettextAnim1Data)
        // console.log(newState)
        setTriggerTime([...triggerTime, gettextAnim1Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: gettextAnim1Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "text_animation_1",
          action_time: gettextAnim1Data.startTime,
          action_end_time:gettextAnim1Data.endTime,
          id:textAnim1Data[0].id
        });
      }

      if(textAnim2Data && textAnim2Data.length > 0){
        let gettextAnim2Data = JSON.parse(textAnim2Data[0].meta_data);
          overlayArr = [].concat(overlayArr, gettextAnim2Data)
        // console.log(newState)
        setTriggerTime([...triggerTime, gettextAnim2Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: gettextAnim2Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "text_animation_2",
          action_time: gettextAnim2Data.startTime,
          action_end_time:gettextAnim2Data.endTime,
          id:textAnim2Data[0].id
        });
      }

      if(emojiContentData && emojiContentData.length > 0){
        emojiContentData.map((emojiContent)=>{
          let getemojiContentData = JSON.parse(emojiContent.meta_data);

            overlayArr = [].concat(overlayArr, {...getemojiContentData,id:emojiContent.id})
            // console.log({...getemojiContentData,id:emojiContent.id})
          setTriggerTime([...triggerTime, getemojiContentData.startTime]);
          dispatch(
            personalizeAction.setTriggerTime({
              personalize_triggerTime: getemojiContentData.startTime,
            })
          );
          // setVideoCTAData(getsimpleRevealData);
          actionPointArr.push({
            action_event: "emoji_content",
            action_time: getemojiContentData.startTime,
            action_end_time:getemojiContentData.endTime,
            id:emojiContent.id
          });

          return true;
        })
        
      }

      // console.log(emojiContentData)
      dispatch(
        personalizeAction.setOverlayData({
          overlayData:overlayArr
        })
      );
      setActionPoint(actionPointArr);
      setPageLoad(true);
    }
  };

  const timeKeyUphandle = (keycode, value) => {
    // console.log(time)
    let step = "01";
    let minutes = Math.floor(videoLength / 60);
    const videoTotalDuration =
      (minutes < 10 ? `0${minutes}` : minutes) +
      ":" +
      ("0" + Math.floor(videoLength % 60)).slice(-2);
    // console.log(value,videoTotalDuration)

    if (keycode === 38 || keycode === "up") {
      // console.log(value,videoLength)

      // console.log(value,videoTotalDuration)
      if (value < videoTotalDuration) {
        const duration = value.split(":");

        if (duration[1] === "59") {
          duration[1] = `0`;

          duration[0] = Number(duration[0]) + Number(step);

          if (duration[0] < 10) {
            duration[0] = `0${duration[0]}`;
          }
        } else {
          duration[1] = Number(duration[1]) + Number(step);
        }
        if (duration[1] < 10) {
          duration[1] = `0${duration[1]}`;
        }

        return `${duration[0]}:${duration[1]}`;
      } else {
        return value;
      }
    } else if (keycode === 40 || keycode === "down") {
      const duration = value.split(":");

      if (duration[1] === "00" && duration[0] === "00") {
        duration[1] = `00`;
        return false;
      }

      if (duration[1] === "00") {
        duration[1] = `59`;

        duration[0] = Number(duration[0]) - Number(step);

        if (duration[0] < 10) {
          duration[0] = `0${duration[0]}`;
        }
      } else {
        duration[1] = Number(duration[1]) - Number(step);
      }

      if (duration[1] < 10) {
        duration[1] = `0${duration[1]}`;
      }

      return `${duration[0]}:${duration[1]}`;
    } else {
      return value;
    }
  };

  const handleTimeKeyUp = (event, type) => {
    event.preventDefault();
    // console.log(event.keyCode)
    
    const { value } = event.target;
    // console.log(value,type,event.keyCode)
    let changeDur;
    changeDur = timeKeyUphandle(event.keyCode, value);
    // console.log(changeDur)
    if (!changeDur) changeDur = "00:00";

    if (type === "ctaTime")
      setVideoCTAData({ ...videoCTAData, actiontime: changeDur });

    if (type === "annotationStartTime")
      setAnnotationData({ ...annotationData, annotationStartTime: changeDur });

    if (type === "annotationEndTime")
      setAnnotationData({ ...annotationData, annotationEndTime: changeDur });

    if (type === "CRMstartTime")
      setCopyPasteData({ ...copyPasteData, CRMstartTime: changeDur });

    if (type === "CRMendTime")
      setCopyPasteData({ ...copyPasteData, CRMendTime: changeDur });

    if (type === "leadgenTime")
      setLeadgenFormData({ ...leadgenFormData, leadgenTime: changeDur });

    if (type === "pollTime")
      setCustPollData({ ...custPollData, pollTime: changeDur });

    if (type === "startTime")
      setShowAnimation({...showAnimation,startTime:changeDur})

    if (type === "endTime")
      setShowAnimation({...showAnimation,endTime:changeDur})

    if(type === "setStartTime")
      setYtPlayer({...ytPlayer,start:changeDur})

    if(type === "setEndTime")
      setYtPlayer({...ytPlayer,end:changeDur})

  };

  const handleTimeBlur = (event, type) => {
    event.preventDefault();
    const { value } = event.target;
    let changeDur;

    let re = /^\d{1,2}:\d{2}([ap]m)?$/;

    if (value !== "" && !value.match(re)) {
      changeDur = "00:00";
    } else {
      changeDur = value;
    }

    if (type === "ctaTime")
      setVideoCTAData({ ...videoCTAData, actiontime: changeDur });

    if (type === "annotationStartTime")
      setAnnotationData({ ...annotationData, annotationStartTime: changeDur });

    if (type === "annotationEndTime")
      setAnnotationData({ ...annotationData, annotationEndTime: changeDur });

    if (type === "CRMstartTime")
      setCopyPasteData({ ...copyPasteData, CRMstartTime: changeDur });

    if (type === "CRMendTime")
      setCopyPasteData({ ...copyPasteData, CRMendTime: changeDur });

    if (type === "leadgenTime")
      setLeadgenFormData({ ...leadgenFormData, leadgenTime: changeDur });

    if (type === "pollTime")
      setCustPollData({ ...custPollData, pollTime: changeDur });

    if (type === "startTime")
      setShowAnimation({...showAnimation,startTime:changeDur})

    if (type === "endTime")
      setShowAnimation({...showAnimation,endTime:changeDur})

    if(type === "setStartTime")
      setYtPlayer({...ytPlayer,start:changeDur})

    if(type === "setEndTime")
      setYtPlayer({...ytPlayer,end:changeDur})
  };

  const handleTimeUpDown = (event, type, action) => {
    event.preventDefault();
    let changeDur, value;
    if (action === "ctaTime") value = timeRef.current.value;

    if (action === "annotationStartTime")
      value = annoStartTimeRef.current.value;

    if (action === "annotationEndTime") value = annoEndtimeRef.current.value;

    if (action === "CRMstartTime") value = CRMstartTimeRef.current.value;

    if (action === "CRMendTime") value = CRMendtimeRef.current.value;

    if (action === "leadgenTime") value = leadgenTimeRef.current.value;

    if (action === "pollTime") value = pollTimeRef.current.value;

    if (action === "startTime") value = startTimeRef.current.value;
    if (action === "endTime") value = endTimeRef.current.value;

    if(action === "setStartTime") value = setStartTimeRef.current.value;

    if(action === "setEndTime") value = setEndTimeRef.current.value;

    // console.log(value,type)
    changeDur = timeKeyUphandle(type, value);

    if (!changeDur) changeDur = "00:00";
    console.log(changeDur);
    if (action === "ctaTime")
      setVideoCTAData({ ...videoCTAData, actiontime: changeDur });

    if (action === "annotationStartTime")
      setAnnotationData({ ...annotationData, annotationStartTime: changeDur });

    if (action === "annotationEndTime")
      setAnnotationData({ ...annotationData, annotationEndTime: changeDur });

    if (action === "CRMstartTime")
      setCopyPasteData({ ...copyPasteData, CRMstartTime: changeDur });

    if (action === "CRMendTime")
      setCopyPasteData({ ...copyPasteData, CRMendTime: changeDur });

    if (action === "leadgenTime")
      setLeadgenFormData({ ...leadgenFormData, leadgenTime: changeDur });

    if (action === "pollTime")
      setCustPollData({ ...custPollData, pollTime: changeDur });

    if (action === "startTime")
      setShowAnimation({...showAnimation,startTime:changeDur})

    if (action === "endTime")
      setShowAnimation({...showAnimation,endTime:changeDur})

    if(action === "setStartTime")
      setYtPlayer({...ytPlayer,start:changeDur})

    if(action === "setEndTime")
      setYtPlayer({...ytPlayer,end:changeDur})
  };

  const handleImageChange = async (event) => {
    // console.log('joo');
    try {
      if (checkFileSize(event) && checkMimeType(event)) {
        // EditorContextData.loadingHandler(true);
        // document.getElementById("imageglrybx").classList.remove('show');
        // console.log(event.target.files[0]);
        // let imageDataUrl = await readFile(event.target.files[0]);

        UploadService.upload(event.target.files[0], token, (event) => {
          console.log(Math.round((100 * event.loaded) / event.total));
        })
        .then((response) => {
          // console.log(response.status);
          const imgLink = response.data.url;
          if (response.status === 200) {
            setVideoCTAData({ ...videoCTAData, image: imgLink });
          }
        })

        // EditorContextData.loadingHandler(false);

        event.target.value = "";
      }
    } catch (err) {
      console.log(err);
    }
  };

  // function readFile(file) {
  //   return new Promise((resolve) => {
  //     const reader = new FileReader();
  //     reader.addEventListener("load", () => resolve(reader.result), false);
  //     reader.readAsDataURL(file);
  //   });
  // }

  const checkMimeType = (event) => {
    //getting file object
    let files = event.target.files;
    //define message container
    let err = "";
    // list allow mime type
    const types = ["image/png", "image/jpeg", "image/gif"];
    // loop access array

    //    console.log(files.length);
    if (types.every((type) => files[0].type !== type)) {
      // create error message and assign to container
      err +=
        files[0].type +
        " is not a supported format\n please upload JPG/PNG Images";
    }

    if (err !== "") {
      // if message not same old that mean has error
      event.target.value = null; // discard selected file
      // console.log(err)
      cuteToast({
        type: "error",
        message: err,
        timer: 5000,
        title: "",
      });
      return false;
    }
    return true;
  };

  const checkFileSize = (event) => {
    let files = event.target.files;
    let size = 2000000;
    let err = "";
    for (var x = 0; x < files.length; x++) {
      // console.log(files[x].size);
      if (files[x].size > size) {
        err +=
          files[x].type +
          " is too large, please pick a smaller file\n which is less than 4MB";
      }
    }
    if (err !== "") {
      event.target.value = null;
      // console.log(err)
      cuteToast({
        type: "error",
        message: err,
        timer: 5000,
        title: "",
      });
      return false;
    }

    return true;
  };

  const handleMeetingData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(videoMeetingData, "meeting");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...videoMeetingData,
            camp_id,
            type: "video_meeting",
          },
        },
        (response) => {
          if (response.status === 200) {
            let mints = Math.floor(videoLength / 60);
            let meetingDuration =
              (mints < 10 ? `0${mints}` : mints) +
              ":" +
              ("0" + Math.floor(videoLength % 60)).slice(-2);
            setShowMeetingLink(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_meeting"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_meeting"
                  ? { ...obj, action_time: meetingDuration }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                { action_event: "video_meeting", action_time: meetingDuration,id:response.id},
              ]);
            }

            setTriggerTime([...triggerTime, meetingDuration]);
            dispatch(
              personalizeAction.setTriggerTime({
                personalize_triggerTime: videoLength,
              })
            );
            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Meeting Timeline",
            });
          }
        }
      );
    }
  };

  const handleCTAData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(videoCTAData, "cta");
    // const objIndex = actionPoint.findIndex(
    //   (obj) => (obj.action_event === "video_cta" && obj.action_time === videoCTAData.actiontime)
    // )
    // console.log(objIndex)
    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      setTriggerTime([...triggerTime, videoCTAData.actiontime]);
      dispatch(
        personalizeAction.setTriggerTime({
          personalize_triggerTime: videoCTAData.actiontime,
        })
      );
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...videoCTAData,
            camp_id,
            type: "video_cta",
          },
        },
        (response) => {
          // console.log(response);
          if (response.status === 200) {
            setShowCTA(false);
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_cta"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_cta"
                  ? { ...obj, action_time: videoCTAData.actiontime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_cta",
                  action_time: videoCTAData.actiontime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Call To Action Timeline",
            });
          }
        }
      );
    }
  };

  const handleAnnotationData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(annotationData, "annotation");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      if (validateData.annotationEndTime) {
        cuteToast({
          type: "error",
          message: validateData.annotationEndTime,
          timer: 5000,
          title: "Annotation",
        });
      }

      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...annotationData,
            camp_id,
            type: "video_annotation",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowAnnotation(false);
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_annotation"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_annotation"
                  ? { ...obj, action_time: annotationData.annotationStartTime,action_end_time:annotationData.annotationEndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_annotation",
                  action_time: annotationData.annotationStartTime,
                  action_end_time:annotationData.annotationEndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Annotation Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleCopyPasteData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(copyPasteData, "copyPaste");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...copyPasteData,
            camp_id,
            type: "video_copypaste",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowCopyPaste(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_copypaste"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_copypaste"
                  ? { ...obj, action_time: copyPasteData.CRMstartTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_copypaste",
                  action_time: copyPasteData.CRMstartTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Copy Paste Form Timeline",
            });
          }
        }
      );
    }
  };

  const handleLeadGenData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(leadgenFormData, "leadgenForm");
    // const objIndex = actionPoint.findIndex(
    //   (obj) => (obj.action_event === "video_leadgen" && obj.action_time === leadgenFormData.leadgenTime)
    // )

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      // setTriggerTime([...triggerTime, leadgenFormData.leadgenTime]);
      dispatch(
        personalizeAction.setTriggerTime({
          personalize_triggerTime: leadgenFormData.leadgenTime,
        })
      );
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...leadgenFormData,
            camp_id,
            type: "video_leadgen",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLeadGenForm(false);
            const objactIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_leadgen"
            );
            // console.log(objIndex)
            if (objactIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_leadgen"
                  ? { ...obj, action_time: leadgenFormData.leadgenTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_leadgen",
                  action_time: leadgenFormData.leadgenTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Trigger Reel Form Timeline",
            });
          }
        }
      );
    }
  };

  const handlePollData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(custPollData, "customPoll");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...custPollData,
            camp_id,
            type: "video_custPoll",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowCustomPoll(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_custPoll"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_custPoll"
                  ? { ...obj, action_time: custPollData.pollTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_custPoll",
                  action_time: custPollData.pollTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Custom Poll Timeline",
            });
          }
        }
      );
    }
  };

  const getSeconds = (time) =>{
    // console.log(time)
    if(time === 0 || time === '0'){
      return time;
    }
    let duration = time.split(":");
    let sec = (parseInt(duration[0] * 60) + parseInt(duration[1]));
    return sec;
  }

  const handleEditTrigger = (e, trigger,id) => {
    e.preventDefault();
    // console.log(trigger)
    setShowMeetingLink(false);
    setShowCTA(false);
    setShowAnnotation(false);
    setShowCopyPaste(false);
    setShowLeadGenForm(false);
    setShowCustomPoll(false);
    setErrors({})
    setShowIcons(false);
    setShowOverlay(false)
    setShowLowerThird(false)
    setShowIcons(false);
    setShowEffectControls(false)
    setShowTimingControl(false)
    setShowActiveTrigger(trigger)

    setShowAnimation({
      ...showAnimation,
      animationType:"",
      simpleRevealShow:false,
      nameAnim:false,
      textAnim1:false,
      textAnim2:false,
      speechBubble:false,
      speechBubble2:false,
      speechBubble3:false,
      speechThought:false,
      borderAnim:false,
      borderAnim2:false,
      ltAnimation1:false,
      ltAnimation3:false,
      ltAnimation2:false,
      ltAnimation4:false,
      ltAnimation5:false,
      smiley:false
    })

    trigger === "video_meeting" && setShowMeetingLink(true);
    if(trigger === "video_cta"){
      setShowCTA(true);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(videoCTAData.actiontime)/ytPlayer.duration),
        playedSeconds:getSeconds(videoCTAData.actiontime)
      })
    }
    
    if(trigger === "video_copypaste"){
      setShowCopyPaste(true);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(copyPasteData.CRMstartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(copyPasteData.CRMstartTime)
      })
    }
    trigger === "video_leadgen" && setShowLeadGenForm(true);
    if(trigger === "video_custPoll"){
      setShowCustomPoll(true);
      setShowTimingControl(false);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(custPollData.pollTime)/ytPlayer.duration),
        playedSeconds:getSeconds(custPollData.pollTime)
      })
    }

    if(trigger === "video_annotation"){
      setShowAnnotation(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(annotationData.annotationStartTime),
        end:getSeconds(annotationData.annotationEndTime),
        played:(getSeconds(annotationData.annotationStartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(annotationData.annotationStartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "simple_reveal"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let revealData = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Simple Reveal Text",
        text1:revealData[0].text1,
        text2:revealData[0].text2,
        simpleRevealShow:revealData[0].simpleRevealShow,
        startTime: revealData[0].startTime,
        endTime : revealData[0].endTime,
        xPosition : revealData[0].xPosition,
        yPosition : revealData[0].yPosition,
        text1FontFamily:revealData[0].text1FontFamily,
        text1FontSize:revealData[0].text1FontSize,
        text1FontColor:revealData[0].text1FontColor,
        text1BgColor:revealData[0].text1BgColor,
        text2FontFamily:revealData[0].text2FontFamily,
        text2FontSize:revealData[0].text2FontSize,
        text2FontColor:revealData[0].text2FontColor,
        text2BgColor:revealData[0].text2BgColor,
        width:revealData[0].width,
        height:revealData[0].height,
        bgTheme:revealData[0].bgTheme,
        nameAnim:false,
        speechBubble:false,
        speechBubble2:false,
        speechBubble3:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(revealData[0].width)
      setHeight(revealData[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(revealData[0].startTime),
        end:getSeconds(revealData[0].endTime),
        played:(getSeconds(revealData[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(revealData[0].startTime)
      })
      setShowTimingControl(true) 

    }

    if(trigger === "speech_bubble"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(data)
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:data[0].text1,
        speechBubble:data[0].speechBubble,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        simpleRevealShow:false,
        nameAnim:false,
        speechBubble2:false,
        speechBubble3:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "speech_bubble_2"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:data[0].text1,
        text2:data[0].text2,
        speechBubble2:data[0].speechBubble2,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        simpleRevealShow:false,
        nameAnim:false,
        speechBubble:false,
        speechBubble3:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "speech_bubble_3"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:data[0].text1,
        speechBubble3:data[0].speechBubble3,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "speech_thought"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      console.log(data)
      setShowAnimation({
        ...showAnimation,
        name:"Speech Thought",
        text1:data[0].text1,
        speechThought:data[0].speechThought,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "border_animation"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Border Animation",
        text1:data[0].text1,
        borderAnim:data[0].borderAnim,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        text2BgColor:data[0].text2BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "border_animation_2"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Border Animation",
        text1:data[0].text1,
        borderAnim2:data[0].borderAnim2,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_1"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        text2:data[0].text2,
        ltAnimation1:data[0].ltAnimation1,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        bgTheme:data[0].bgTheme,
        text2BgColor:data[0].text2BgColor,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_2"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        text2:data[0].text2,
        ltAnimation2:data[0].ltAnimation2,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation3:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_3"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        text2:data[0].text2,
        ltAnimation3:data[0].ltAnimation3,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_4"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        ltAnimation4:data[0].ltAnimation4,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        bgTheme:data[0].bgTheme,
        text2BgColor:data[0].text2BgColor,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_5"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        text2:data[0].text2,
        ltAnimation5:data[0].ltAnimation5,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        text2BgColor:data[0].text2BgColor,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "name_animation"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowEffectControls(true)
      setShowIcons(false);
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(overlayData)
      setShowAnimation({
        ...showAnimation,
        name:"Name Overlay",
        text1:data[0].text1,
        nameAnim:data[0].nameAnim,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        width:data[0].width,
        height:data[0].height,
        animationType:data[0].animationType,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "text_animation_1"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowEffectControls(true)
      setShowIcons(false);
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(overlayData)
      setShowAnimation({
        ...showAnimation,
        name:"Text Overlay",
        text1:data[0].text1,
        textAnim1:data[0].textAnim1,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        width:data[0].width,
        height:data[0].height,
        animationType:data[0].animationType,
        nameAnim:false,
        textAnim2:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "text_animation_2"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowEffectControls(true)
      setShowIcons(false);
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(overlayData)
      setShowAnimation({
        ...showAnimation,
        name:"Text Overlay",
        text1:data[0].text1,
        textAnim2:data[0].textAnim2,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        width:data[0].width,
        height:data[0].height,
        animationType:data[0].animationType,
        nameAnim:false,
        textAnim1:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }


    if(trigger === "emoji_content"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowEffectControls(true)
      setShowIcons(true);
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(data)
      // console.log(data.findIndex((obj)=>obj.id === id))
      setShowAnimation({
        ...showAnimation,
        name:"Smiley",
        text1:data[data.findIndex((obj)=>obj.id === id)].text1,
        smiley:data[data.findIndex((obj)=>obj.id === id)].smiley,
        startTime: data[data.findIndex((obj)=>obj.id === id)].startTime,
        endTime : data[data.findIndex((obj)=>obj.id === id)].endTime,
        xPosition : data[data.findIndex((obj)=>obj.id === id)].xPosition,
        yPosition : data[data.findIndex((obj)=>obj.id === id)].yPosition,
        width:data[data.findIndex((obj)=>obj.id === id)].width,
        height:data[data.findIndex((obj)=>obj.id === id)].height,
        smileyContent:data[data.findIndex((obj)=>obj.id === id)].smileyContent,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        ltAnimation5:false,
      })
      setActiveElelment(id)
      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    setShowActiveTrigger(trigger)
    setShowTimingControl(true)
  };

  const handleDeleteTrigger = (e, trigger,actionTime,id) => {
    e.preventDefault();

    deletePersonalizeData(
      {
        url: endPoints.deletePersonalize,
        method: "POST",
        body: { camp_id, id },
      },
      (response) => {
        if (response.status === 200 && response.message === "deleted") {
          if (trigger === "video_meeting") {
            dispatch(
              personalizeAction.setMeetingData({ personalize_meetingData: {} })
            );
            // var result = arrayRemove(actionPoint,trigger);
            let mints = Math.floor(videoLength / 60);
            let meetingDuration =
              (mints < 10 ? `0${mints}` : mints) +
              ":" +
              ("0" + Math.floor(videoLength % 60)).slice(-2);
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setTriggerTime(
              arrayRemove(triggerTime, meetingDuration, "triggerTime")
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: meetingDuration,
              })
            );
            setVideoMeetingData({
              fullname: "",
              designation: "",
              buttontext: "",
              meetingLink: "",
              buttonColor: "#00b2eb",
            });
          }

          if (trigger === "video_cta") {
            dispatch(personalizeAction.setCTAData({ personalize_CTAData: {} }));
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: videoCTAData.actiontime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, videoCTAData.actiontime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setVideoCTAData({
              formtype: "text",
              text: "",
              image: "",
              link: "",
              actiontime: "00:00",
            });
          }

          if (trigger === "video_annotation") {
            dispatch(
              personalizeAction.setAnnotationData({
                personalize_AnnotationData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: annotationData.annotationStartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                annotationData.annotationStartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setAnnotationData({
              annotationText: "Click on this link",
              annotationLink: "",
              annotationStartTime: "00:00",
              annotationEndTime: "00:00",
            });
          }

          if (trigger === "video_copypaste") {
            dispatch(
              personalizeAction.setCopyPasteData({
                personalize_copyPasteData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: copyPasteData.CRMstartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                copyPasteData.CRMstartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setCopyPasteData({
              CRMHtmlText: "",
              CRMskipCheck: true,
              bgCRMTheme: true,
              CRMstartTime: "00:00",
              CRMendTime: "00:00",
            });
          }

          if (trigger === "video_leadgen") {
            dispatch(
              personalizeAction.setLeadgenFormData({
                personalize_leadgenFormData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: leadgenFormData.leadgenTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                leadgenFormData.leadgenTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLeadgenFormData({
              askphonechk: false,
              askcompanychk: false,
              headline: "Enter the following details to continue playing",
              buttonname: "Play",
              note: "Note",
              leadgenTime: "00:00",
              leadgenSkipCheck: true,
            });
          }

          if (trigger === "video_custPoll") {
            dispatch(
              personalizeAction.setPollData({ personalize_pollData: {} })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: custPollData.pollTime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, custPollData.pollTime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setCustPollData({
              question: "Your Question ?",
              option1: "Yes",
              option2: "No",
              option3: "",
              pollTime: "00:00",
              pollSkipChk: true,
            });
          }

          if (trigger === "name_animation") {
            
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: actionTime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, actionTime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));

            dispatch(
              personalizeAction.setDeleteOverlayData({
                personalize_trigger: trigger,
              })
            );
            
          }

          if (trigger === "simple_reveal" || trigger === "speech_bubble" || trigger === "speech_bubble_2" || trigger === "speech_thought" ||
              trigger === "speech_bubble_3" || trigger === "border_animation" || trigger === "border_animation_2" || trigger === "lt_animation_1" || 
              trigger === "lt_animation_2" || trigger === "lt_animation_3" || trigger === "lt_animation_4" || trigger === "lt_animation_5") 
          {
            
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: actionTime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, actionTime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));

            dispatch(
              personalizeAction.setDeleteOverlayData({
                personalize_trigger: trigger,
              })
            );
          }

          if (trigger === "emoji_content" && id !== '') {
            
            const objIndex = actionPoint.findIndex(
              (obj) => obj.id === id
            );

            if(objIndex >= 0){
              dispatch(
                personalizeAction.setDeleteTriggerTime({
                  personalize_triggerTime: actionTime,
                })
              );
              setTriggerTime(
                arrayRemove(triggerTime, actionTime, "triggerTime")
              );
              setActionPoint(arrayRemove(actionPoint, id, "action_emoji"));
                
              dispatch(
                personalizeAction.setDeleteOverlayData({
                  personalize_trigger: id,
                })
              );
            }
            
          }

          cuteToast({
            type: "success",
            message: "Deleted Successfully.",
            timer: 5000,
            title: `${trigger.replace(/_/g, " ")} Timeline`,
          });

        }
      }
    );
  };

  function arrayRemove(arr, value, type) {
    if (type === "action_event") {
      return arr.filter(function (ele) {
        return ele.action_event !== value;
      });
    } else if (type === "triggerTime") {
      return arr.filter(function (ele) {
        return ele !== value;
      });
    }else if (type === 'action_emoji'){
      return arr.filter(function (ele) {
        return ele.id !== value;
      });
    }
  }

  const getActioTime = (time) => {
    // console.log(time,videoLength)
    let duration = time.split(":");
    let sec = (parseInt(duration[0] * 60) + parseInt(duration[1]));
    // console.log(sec,videoLength)
    return (sec / videoLength) * 100 + "%";
  };

  const handleEffectSetting = (e,type) =>{
    e.preventDefault();
    setShowOverlay(false)
    setShowLowerThird(false)
    setShowEffectControls(true)
    // console.log(format(ytPlayer.loaded * ytPlayer.played))
    if(type === 'simple_reveal'){
      setShowAnimation({
        ...showAnimation,
        name:"Simple Reveal Text",
        text1:"Simple Reveal Effect",
        text2:"Using HTML And CSS",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        text1BgColor:"#f9ff57",
        text2FontFamily:"Montserrat",
        text2FontSize:"28",
        text2FontColor:"#ffffff",
        text2BgColor:"#9933ab",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        simpleRevealShow:true
      })
      setWidth(390)
      setHeight(180)
    }else if(type === 'speech_bubble'){
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem quos",
        text1FontFamily:"Montserrat",
        text1FontSize:"18",
        text1FontColor:"#8b8888",
        text1BgColor:"#904ece",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechBubble:true
      })
      setWidth(200)
      setHeight(120)
    }else if(type === 'speech_thought'){
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble Thought",
        text1:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem quos",
        text1FontFamily:"Montserrat",
        text1FontSize:"18",
        text1FontColor:"#8b8888",
        text1BgColor:"#904ece",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechThought:true
      })
      setWidth(400)
      setHeight(120)
    }else if(type === 'speech_bubble_2'){
      setShowAnimation({
        ...showAnimation,
        name:"Preset Horizontal Wobble",
        text1:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem quos",
        text2:"Autem quos",
        text1FontFamily:"Montserrat",
        text1FontSize:"24",
        text1FontColor:"#ffffff",
        text1BgColor:"#1abc9c",
        text2FontFamily:"Montserrat",
        text2FontSize:"14",
        text2FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechBubble2:true
      })
      setWidth(400)
      setHeight(210)
    }else if(type === 'speech_bubble_3'){
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:"Lorem ipsum dolor sit amet !",
        text1FontFamily:"Montserrat",
        text1FontSize:"18",
        text1FontColor:"#8b8888",
        text1BgColor:"#629bdd",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechBubble3:true
      })
      setWidth(320)
      setHeight(120)
    }else if(type === 'speech_bubble_4'){
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:"Lorem ipsum dolor sit amet !",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechBubble4:true
      })
    }else if(type === 'border_animation'){
      setShowAnimation({
        ...showAnimation,
        name:"Border Animation",
        text1:"Lorem ipsum dolor sit amet !",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        text2BgColor:"#ffffff",
        text1BgColor:"#000000",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        borderAnim:true
      })
      setWidth(350)
      setHeight(130)
    }else if(type === 'border_animation_2'){
      setShowAnimation({
        ...showAnimation,
        name:"Border Animation",
        text1:"Lorem ipsum dolor sit amet !",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        text1BgColor:"#787878",
        text2BgColor:"#eaab00",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        borderAnim2:true
      })
      setWidth(300)
      setHeight(250)
    }else if(type === 'lt_animation_1'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John Doe",
        text2:"Motion Designer",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        text2FontFamily:"Montserrat",
        text2FontSize:"28",
        text2FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        text2BgColor:"#cf4c4e",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation1:true
      })
    }else if(type === 'lt_animation_2'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John Doe",
        text2:"Motion Designer",
        text1FontFamily:"Montserrat",
        text1FontSize:"20",
        text1FontColor:"#cf4c4e",
        text2FontFamily:"Montserrat",
        text2FontSize:"20",
        text2FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation2:true
      })
    }else if(type === 'lt_animation_3'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John",
        text2:"Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"38",
        text1FontColor:"#ffffff",
        text2FontFamily:"Montserrat",
        text2FontSize:"40",
        text2FontColor:"#cf4c4e",
        bgTheme:"0,0,0,.75",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation3:true
      })
    }else if(type === 'lt_animation_4'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"42",
        text1FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        text2BgColor:"#cf4c4e",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation4:true
      })
    }else if(type === 'lt_animation_5'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John Doe",
        text2:"Motion Designer",
        text1FontFamily:"Montserrat",
        text1FontSize:"32",
        text1FontColor:"#ffffff",
        text2FontFamily:"Montserrat",
        text2FontSize:"13",
        text2FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        text2BgColor:"#cf4c4e",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation5:true
      })
    }else if(type === 'name_animation'){
      setShowAnimation({
        ...showAnimation,
        name:"Text Overlay",
        text1:"John Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        animationType:"",
        nameAnim:true
      })
      setHeight(100)
    }else if(type === 'text_animation_1'){
      setShowAnimation({
        ...showAnimation,
        name:"Simple Text Animation",
        text1:"John Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        animationType:"",
        textAnim1:true
      })
      setHeight(100)
    }else if(type === 'text_animation_2'){
      setShowAnimation({
        ...showAnimation,
        name:"Simple Text Animation",
        text1:"John Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        animationType:"",
        textAnim2:true
      })
      setHeight(100)
    }else if(type.includes(".svg")){
      // console.log(type)
      var contentArr = [...showAnimation.smileyContent];
      // console.log(contentArr)
          contentArr.push(type)

      if(activeElement){
        setShowAnimation({
          ...showAnimation,
          name:"Smileys",
          text1:type,
          smiley:true,
          smileyContent:contentArr
        })
        
      }else{
        setShowAnimation({
          ...showAnimation,
          name:"Smileys",
          text1:type,
          startTime:Number(ytPlayer.start)? format(ytPlayer.start):"00:00",
          endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
          smiley:true,
          smileyContent:contentArr
        })
      }
      setWidth(150)
      setHeight(100)
    }
    setShowActiveTrigger(type)
    setShowTimingControl(true)

  }

  const handleCloseShowIcon = () =>{
    setShowIcons(false);
    setShowAnimation({
      ...showAnimation,
      smileyContent:[]
    })
    setActiveElelment("")
  }

  const handleClose = (e,type) =>{
    setShowTimingControl(false)
    if(type === 'simple_reveal'){
      setShowAnimation({
        ...showAnimation,
        simpleRevealShow:false
      })
    }

    if(type === 'speech_bubble'){
      setShowAnimation({
        ...showAnimation,
        speechBubble:false
      })
    }

    if(type === 'speech_bubble_2'){
      setShowAnimation({
        ...showAnimation,
        speechBubble2:false
      })
    }

    if(type === 'speech_bubble_3'){
      setShowAnimation({
        ...showAnimation,
        speechBubble3:false
      })
    }

    // if(type === 'speech_bubble_4'){
    //   setShowAnimation({
    //     ...showAnimation,
    //     speechBubble3:false
    //   })
    // }

    if(type === 'speech_thought'){
      setShowAnimation({
        ...showAnimation,
        speechThought:false
      })
    }

    if(type === 'border_animation'){
      setShowAnimation({
        ...showAnimation,
        borderAnim:false
      })
    }

    if(type === 'border_animation_2'){
      setShowAnimation({
        ...showAnimation,
        borderAnim2:false
      })
    }

    if(type === 'lt_animation_1'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation1:false
      })
    }

    if(type === 'lt_animation_2'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation2:false
      })
    }

    if(type === 'lt_animation_3'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation3:false
      })
    }

    if(type === 'lt_animation_4'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation4:false
      })
    }

    if(type === 'lt_animation_5'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation5:false
      })
    }

    if(type === 'name_animation'){
      setShowAnimation({
        ...showAnimation,
        nameAnim:false
      })
    }

    if(type === 'text_animation_1'){
      setShowAnimation({
        ...showAnimation,
        textAnim1:false
      })
    }

    if(type === 'text_animation_2'){
      setShowAnimation({
        ...showAnimation,
        textAnim2:false
      })
    }

    if(type === 'emoji_content'){
      setShowAnimation({
        ...showAnimation,
        smiley:false
      })
      setActiveElelment("")
    }

    setShowEffectControls(false);
  }

  const handleDeleteIcon = (e,icon) =>{
    e.preventDefault();
    let contentArr = showAnimation.smileyContent;
    const removeIconElem = contentArr.filter((svg) => svg !== icon);
    setShowAnimation({
      ...showAnimation,
      smileyContent:removeIconElem
    })
  }

  const handleEffectData = (e,type) =>{
    e.preventDefault();
    // console.log(type)
    if(type === 'simple_reveal' || type === 'speech_bubble' || type === 'speech_bubble_2' || type === 'speech_bubble_3' ||
    type === 'speech_thought' || type === 'speech_bubble_4' || type === 'border_animation' || type === 'border_animation_2' || 
    type === 'lt_animation_1' || type === 'lt_animation_2' || type === 'lt_animation_3' || type === 'lt_animation_4' || 
    type === 'lt_animation_5' || type === 'name_animation' || type === 'text_animation_1' || type === 'text_animation_2'){
      const validateData = validateInfo(showAnimation, type);

      if (Object.keys(validateData).length > 0) {
        setErrors(validateData);
        if (validateData.endTime) {
          cuteToast({
            type: "error",
            message: validateData.endTime,
            timer: 5000,
            title: "",
          });
        }
        return false;
      } else if (Object.keys(validateData).length === 0) {
        updatePersonalizeData(
          {
            url: endPoints.addPersonalize,
            method: "POST",
            body: {
              ...showAnimation,
              camp_id,
              type,
            },
          },
          (response) => {
            if (response.status === 200) {
              setShowEffectControls(false);

              const objIndex = actionPoint.findIndex(
                (obj) => obj.action_event === type
              );
              // console.log(objIndex)
              if (objIndex >= 0) {
                const newState = actionPoint.map((obj) =>
                  obj.action_event === type
                    ? { ...obj, action_time: showAnimation.startTime,action_end_time:showAnimation.endTime }
                    : obj
                );
                setActionPoint(newState);
              } else {
                setActionPoint([
                  ...actionPoint,
                  {
                    action_event: type,
                    action_time: showAnimation.startTime,
                    action_end_time:showAnimation.endTime,
                    id:response.id
                  },
                ]);
              }

              if(type === 'lt_animation_1' || type === 'lt_animation_2' || type === 'lt_animation_3' || 
              type === 'lt_animation_4' || type === 'lt_animation_5'){
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Lower Third Effect Timeline",
                });

              }else if(type === 'name_animation'){
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Name Personalize Timeline",
                });
              }else if(type === 'text_animation_1'){
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Text Personalize Timeline",
                });
              }else if(type === 'text_animation_2'){
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Text Personalize Timeline",
                });
              }else{
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Overlay Effect Timeline",
                });
              }

              setShowAnimation({
                ...showAnimation,
                animationType:"",
                simpleRevealShow:false,
                nameAnim:false,
                textAnim1:false,
                textAnim2:false,
                speechBubble:false,
                speechBubble2:false,
                speechBubble3:false,
                speechThought:false,
                borderAnim:false,
                borderAnim2:false,
                ltAnimation1:false,
                ltAnimation3:false,
                ltAnimation2:false,
                ltAnimation4:false,
                ltAnimation5:false,
                speechBubble4:false
              })

            }
          }
        );
      }
    }

    if(type === "emoji_content"){
      const validateData = validateInfo(showAnimation, type);

      if (Object.keys(validateData).length > 0) {
        setErrors(validateData);
        if (validateData.endTime) {
          cuteToast({
            type: "error",
            message: validateData.endTime,
            timer: 5000,
            title: "",
          });
        }
        return false;
      } else if (Object.keys(validateData).length === 0) {
        updatePersonalizeData(
          {
            url: endPoints.addPersonalize,
            method: "POST",
            body: {
              ...showAnimation,
              camp_id,
              type,
              id:activeElement
            },
          },
          (response) => {
            if (response.status === 200) {
              setShowEffectControls(false);

              const objIndex = actionPoint.findIndex(
                (obj) => obj.id === activeElement
              );
              // console.log(objIndex)
              if (objIndex >= 0) {
                const newState = actionPoint.map((obj) =>
                  obj.id === activeElement
                    ? { ...obj, action_time: showAnimation.startTime }
                    : obj
                );
                setActionPoint(newState);
              } else {
                setActionPoint([
                  ...actionPoint,
                  {
                    action_event: type,
                    action_time: showAnimation.startTime,
                    id:response.id
                  },
                ]);
              }

              cuteToast({
                type: "success",
                message: "Applied Successfully.",
                timer: 5000,
                title: "Icons Timeline",
              });

              setShowAnimation({
                ...showAnimation,
                smiley:false
              })
              setActiveElelment("");
              setShowIcons(false);

              const objOverlayIndex = overlayData.findIndex(
                (obj) => obj.id === activeElement
              );
          
              if (objOverlayIndex >= 0) {
                const newState = overlayData.map((obj) =>
                  obj.id === activeElement
                    ? { ...obj, ...showAnimation }
                    : obj
                );
          
                dispatch(
                  personalizeAction.setOverlayData({
                    overlayData:newState
                  })
                );
          
              }else{
                dispatch(
                  personalizeAction.setOverlayData({
                    overlayData: [{...showAnimation,type,id:activeElement}],
                  })
                );
              }
            }
          }
        );
      }
    }else{
     
      const objOverlayIndex = overlayData.findIndex(
        (obj) => obj.type === type
      );
      const existData = overlayData.filter((obj)=>obj.type !== type);
        
      if (objOverlayIndex >= 0) {
        const newState = overlayData.map((obj) =>
          obj.type === type
            ? { ...obj, ...showAnimation }
            : obj
        );
        
        dispatch(
          personalizeAction.setOverlayData({
            overlayData:newState
          })
        );
  
      }else{
        
        dispatch(
          personalizeAction.setOverlayData({
            overlayData: [].concat(existData, {...showAnimation,type}),
          })
        );
      }
    }

  }

  const DraggableEventHandler = (e,data) =>{
    // e.stopPropagation();
    // console.log(data.node)
    // console.log(data.node.getAttribute("class").includes("simple-reveal-container"))

    if(data.node.getAttribute("class").includes("simple-reveal-container-resize")){
      // console.log('bubble')
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("speech-bubble-container-resize")){
      // console.log('bubble')
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("speech-thought-container-resize")){
      // console.log('thought')
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("speech-bubble-2-container-resize")){
      // console.log('thought')
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("speech-bubble-3-container-resize")){
      // console.log('thought')
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("border-animation-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("border-animation-2-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("name-animation-container-resize")){
      // console.log('bubble')
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("text-animation-1-container-resize")){
      // console.log('bubble')
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }else if(data.node.getAttribute("class").includes("icon-smiley-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y
      })
    }
  }

  const selectStyles = {
    control: base => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: 'none'
    })
  };

  const formatOptionLabel = ({ value, label }) => (
    <span style={{fontFamily:value+",sans-serif"}}>{label}</span>
  );

  const handlePersonalizeClick = (e,type,line) =>{
    if(type === 'name_animation' || type === 'simple_reveal' || 
    type === 'speech_bubble' || type === 'speech_bubble_2' || 
    type === 'speech_bubble_3' || type === 'speech_thought' || 
    type === 'border_animation' || type === 'border_animation_2' || 
    type === 'text_animation_1' || type === 'text_animation_2'){
      // console.log(e.target.innerText)
      if(line === 'text1'){
        const value = showAnimation.text1 + `{{${e.target.innerText}}}`;
        setShowAnimation({
          ...showAnimation,
          text1:value
        })
      }else{
        const value = showAnimation.text2 + `{{${e.target.innerText}}}`;
        setShowAnimation({
          ...showAnimation,
          text2:value
        })
      }
      
    }
  }

  const handleResponderChange = (e) =>{

    const {value} = e.target;
    setLeadgenFormData({
      ...leadgenFormData,
      responderType: value,
    })

    if(value === 'active campaign'){
      const activeCampaign = autoresponder.filter(
        ({ meta_key }) => meta_key === value
      );

      // console.log(activeCampaign)
      if (activeCampaign.length > 0) {
        const meta_data = JSON.parse(activeCampaign[0].meta_data);

        fetchResponderLists(
          {
            url: endPoints.activeCampaignLists,
            method: "POST",
            body: {
              ac_url: meta_data.ac_url,
              ac_key: meta_data.ac_key
            },
          },
          (response) => {
            // console.log(response)
            if(response.statusCode === 200){
              // console.log(response.data)
              setActiveCampaignLists(response.data)
            }
          })
      }
    }

    if(value === 'aweber'){
      const aweber = autoresponder.filter(
        ({ meta_key }) => meta_key === value
      );

      // console.log(activeCampaign)
      if (aweber.length > 0) {
        const meta_data = JSON.parse(aweber[0].meta_data);

        fetchResponderLists(
          {
            url: endPoints.aweberLists,
            method: "POST",
            body: {
              refresh_token: meta_data.refresh_token,
              access_token: meta_data.access_token
            },
          },
          (response) => {
            // console.log(response)
            if(response.statusCode === 200){
              // console.log(response.data)
              setActiveCampaignLists(response.data)
            }
          })
      }
    }

    if(value === "mailchimp"){
      const mailchimp = autoresponder.filter(
        ({ meta_key }) => meta_key === value
      );

      // console.log(activeCampaign)
      if (mailchimp.length > 0) {
        const meta_data = JSON.parse(mailchimp[0].meta_data);

        fetchResponderLists(
          {
            url: endPoints.mailchimpLists,
            method: "POST",
            body: {
              mc_key: meta_data.mc_key
            },
          },
          (response) => {
            // console.log(response)
            if(response.statusCode === 200){
              // console.log(response.data)
              setActiveCampaignLists(response.data)
            }
          })
      }
    }

    if (value === "getresponse") {
      const getresponse = autoresponder.filter(
        ({ meta_key }) => meta_key === value
      );

      // console.log(activeCampaign)
      if (getresponse.length > 0) {
        const meta_data = JSON.parse(getresponse[0].meta_data);

        fetchResponderLists(
          {
            url: endPoints.getResponseLists,
            method: "POST",
            body: {
              gr_key: meta_data.gr_key,
            },
          },
          (response) => {
            // console.log(response)
            if (response.statusCode === 200) {
              // console.log(response.data)
              setActiveCampaignLists(response.data);
            }
          }
        );
      }
    }

  }

  const animationLists = [
    {label:"None",value:""},
    {label:"BackIn Left",value:"animate__backInLeft"},
    {label:"BackIn Down",value:"animate__backInDown"},
    {label:"Bounce In",value:"animate__bounceIn"},
    {label:"rotateIn",value:"animate__rotateIn"},
    {label:"rotateInUpLeft",value:"animate__rotateInUpLeft"},
    {label:"zoomIn",value:"animate__zoomIn"},
    {label:"zoomInUp",value:"animate__zoomInUp"},
    {label:"zoomInDown",value:"animate__zoomInDown"},
    {label:"zoomOut",value:"animate__zoomOut"},
    {label:"zoomOutDown",value:"animate__zoomOutDown"},
    {label:"zoomOutUp",value:"animate__zoomOutUp"},
    {label:"slideInRight",value:"animate__slideInRight"},
    {label:"slideInLeft",value:"animate__slideInLeft"},
    {label:"flipInX",value:"animate__flipInX"},
    {label:"flipInY",value:"animate__flipInY"},
  ]

  const handleDuration = (duration) =>{
    // console.log('onDuration', duration)
    setYtPlayer({
      ...ytPlayer,
      duration:duration
    })
  }

  const handleProgress = (state) =>{
    // console.log('onProgress', state)
    // We only want to update time slider if we are not currently seeking
    if (!ytPlayer.seeking) {
      setYtPlayer({
        ...ytPlayer,
        loaded:state.loaded,
        played:state.played,
        playedSeconds:state.playedSeconds,
        // start:(ytPlayer.duration * state.played),
        // end:((ytPlayer.duration * state.played) + 5)
      })
      // console.log('inn')
    }

    if(isPlayInBetween && !ytPlayer.playing){
      setYtPlayer({
        ...ytPlayer,
        url:ytPlayer.url.split("&start=")[0]
      })
    }

    
    // console.log(format(ytPlayer.duration * ytPlayer.played),format(ytPlayer.playedSeconds))
  }

  const handleSeekMouseDown = e => {
    // console.log(e,"handleSeekMouseDown")
    setYtPlayer({
      ...ytPlayer,
      seeking:true
    })
  }

  const handleSeekChange = e => {
    // console.log(e,"handleSeekChange",parseFloat(e.target.value))
    setYtPlayer({
      ...ytPlayer,
      played:parseFloat(e.target.value),
      start:(ytPlayer.duration * parseFloat(e.target.value)),
      end:((ytPlayer.duration * parseFloat(e.target.value)) + 5.0),
      playedSeconds:(ytPlayer.duration * parseFloat(e.target.value))
    })

    if(showCTA){
      setVideoCTAData({
        ...videoCTAData,
        actiontime:format(ytPlayer.duration * parseFloat(e.target.value))
      })
    }

    if(showCopyPaste){
      setCopyPasteData({
        ...copyPasteData,
        CRMstartTime:format(ytPlayer.duration * parseFloat(e.target.value))
      })
    }

    if(showCustomPoll){
      setCustPollData({
        ...custPollData,
        pollTime:format(ytPlayer.duration * parseFloat(e.target.value))
      })
    }

    // console.log(format(ytPlayer.duration * ytPlayer.played))
  }

  const handleSeekMouseUp = e => {
    // console.log(e,"handleSeekMouseUp")
    setYtPlayer({
      ...ytPlayer,
      seeking:false
    })
    ytPlayerRef.current.seekTo(parseFloat(e.target.value))
    
  }

  function format (seconds) {
    // console.log(seconds)
    const date = new Date(seconds * 1000)
    const hh = date.getUTCHours()
    const mm = date.getUTCMinutes()
    const ss = pad(date.getUTCSeconds())
    if (hh) {
      return `${hh}:${pad(mm)}:${ss}`
    }
    return `${pad(mm)}:${pad(ss)}`
  }
  
  function pad (string) {
    return ('0' + string).slice(-2)
  }

  const toggleYtMute = () =>{
    setYtPlayer({
      ...ytPlayer,
      muted:!ytPlayer.muted
    })
  }

  const handleYtAudioLevel = (value) =>{
    if(value > 0){
      setYtPlayer({
        ...ytPlayer,
        volume:value,
        muted:false
      })
    }else{
      setYtPlayer({
        ...ytPlayer,
        volume:value,
        muted:true
      })
    }
  }
  
  if(showEffectControls && !isFontLoaded){
    WebFont.load({
      google: {
        families: ['Uncial Antiqua','Metal Mania','Atomic Age','Emblema One','Miltonian','Poppins','Staatliches','Caveat','Satisfy','Electrolize','Luckiest Guy','Audiowide','Pangolin','Merienda One','Capriola','Fredericka the Great','Aladin','Alegreya SC','Ceviche One','Lemon','Abril+Fatface', 'Anton', 'Dancing+Script', 'Droid+Sans', 'Droid+Serif', 'Gloria+Hallelujah', 'Indie+Flower', 'Lato', 'Lobster', 'Lora', 'Montserrat', 'Open+Sans', 'Oswald', 'PT+Sans', 'PT+Serif', 'Pacifico', 'Playfair+Display', 'Raleway', 'Roboto', 'Roboto+Condensed', 'Roboto+Slab', 'Rubik', 'Slabo+27px', 'Source+Sans+Pro', 'Ubuntu', 'Monoton', 'Bungee+Inline', 'Black+Ops+One', 'Finger+Paint', 'Bungee+Shade', 'Ribeye+Marrow', 'Suez+One', 'Teko', 'Josefin+Sans', 'Acme', 'Varela Round', 'Archivo Black', 'Berkshire Swash', 'Righteous', 'Concert One', 'Fredoka One', 'Limelight', 'Cabin Sketch', 'Electrolize', 'Niconne', 'Aclonica', 'Reem Kufi', 'Love Ya Like A Sister', 'Vast Shadow', 'Ravi Prakash', 'Germania One', 'Nosifer', 'Pirata One', 'Rubik Mono One', 'Butcherman', 'Great Vibes', 'Teko', 'Quicksand', 'Bree+Serif', 'Francois+One', 'Kaushan+Script', 'Patua+One', 'Permanent+Marker', 'Alfa+Slab+One', 'Cookie', 'Lalezar', 'Patrick+Hand', 'Passion+One', 'Boogaloo', 'Paytone+One', 'Playball', 'Fugaz+One', 'Oleo+Script', 'Knewave', 'Bevan', 'Faster+One', 'Leckerli+One', 'Bungee', 'Pattaya', 'Rye', 'Federo', 'Nova+Square', 'Ranchers', 'New+Rocker']

      }            
    });
    setIsFontLoaded(true)
  }

  const handleTriggerTime = (value) =>{
    console.log('A'+Math.random(1,100))
    let start = value[0];
    let end = value[1];
    let startDuration = ((start / 100) * ytPlayer.duration);
    let endDuration = ((end / 100) * ytPlayer.duration);

    setYtPlayer({
      ...ytPlayer,
      start:startDuration,
      end:endDuration
    })

    // handlePlayBetween();
  }

  const handlePlayAfter = (value) =>{
    // console.log('B'+Math.random(1,100))
    let start = value[0];
    let end = value[1];
    let startDuration = ((start / 100) * ytPlayer.duration);
    let endDuration = ((end / 100) * ytPlayer.duration);
    // console.log(ytPlayer,startDuration,endDuration);
    setYtPlayer({
      ...ytPlayer,
      start:startDuration,
      end:endDuration,
      playing:false
    })

    // handlePlayBetween(startDuration,endDuration);
  }

  const handleSetTime = (event) =>{
    event.preventDefault();
    if(showActiveTrigger && showActiveTrigger === 'video_annotation'){
      setAnnotationData({
        ...annotationData,
        annotationStartTime: Number(ytPlayer.start)?format(ytPlayer.start):ytPlayer.start,
        annotationEndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && (showActiveTrigger === "simple_reveal" || 
    showActiveTrigger === "speech_bubble" || 
    showActiveTrigger === "speech_bubble_2" || 
    showActiveTrigger === "speech_bubble_3" || 
    showActiveTrigger === "speech_bubble_4" || 
    showActiveTrigger === "speech_thought" || 
    showActiveTrigger === "border_animation" || 
    showActiveTrigger === "border_animation_2" || 
    showActiveTrigger === "lt_animation_1" || 
    showActiveTrigger === "lt_animation_2" || 
    showActiveTrigger === "lt_animation_3" || 
    showActiveTrigger === "lt_animation_4" || 
    showActiveTrigger === "lt_animation_5" || 
    showActiveTrigger === "name_animation" || 
    showActiveTrigger === "text_animation_1" || 
    showActiveTrigger === "text_animation_2" || 
    showActiveTrigger.includes(".svg"))){
      setShowAnimation({
        ...showAnimation,
        startTime: Number(ytPlayer.start)?format(ytPlayer.start):ytPlayer.start,
        endTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    cuteToast({
      type: "success",
      message: "Time Updated.",
      timer: 5000,
      title: "Trigger Timeline",
    });
  }

  const handlePlayBetween = (startDuration,endDuration) =>{

    let ytPlayerUrl = ytPlayer.url;
    if(campaign_data && campaign_data.video_type === 'embed'){
      if(ytPlayer.url.includes("&start=")){
        ytPlayerUrl = ytPlayer.url.split("&start=")[0]
      }
      // console.log(ytPlayer,startDuration,endDuration)
      if(startDuration && endDuration){
        setYtPlayer({
          ...ytPlayer,
          url:`${ytPlayerUrl}&start=${startDuration}&end=${endDuration}`,
          start:startDuration,
          end:endDuration,
          playing:true,
        })
      }else{
        setYtPlayer({
          ...ytPlayer,
          url:`${ytPlayerUrl}&start=${Number(ytPlayer.start)?ytPlayer.start:getSeconds(ytPlayer.start)}&end=${Number(ytPlayer.end)?ytPlayer.end:getSeconds(ytPlayer.end)}`,
          playing:true,
        })
      }
    }else{
      if(ytPlayer.url.includes("#t=")){
        ytPlayerUrl = ytPlayer.url.split("#t=")[0]
      }
      // console.log(ytPlayer,startDuration,endDuration)
      if(startDuration && endDuration){
        setYtPlayer({
          ...ytPlayer,
          url:`${ytPlayerUrl}#t=${startDuration},${endDuration}`,
          start:startDuration,
          end:endDuration,
          playing:true,
        })
      }else{
        setYtPlayer({
          ...ytPlayer,
          url:`${ytPlayerUrl}#t=${ytPlayer.start},${ytPlayer.end}`,
          playing:true,
        })
      }
    }
    
    setIsPlayInBetween(true)
  }

  return (
    <>
      <div className="p-4 pb-2 pt-5">
        <div className="video_action_main_wrap row">
          <div className="col-xl-5 col-lg-5 col-md-12">
            { !showMeetingLink &&
              !showCTA &&
              !showAnnotation &&
              !showCopyPaste &&
              !showLeadGenForm &&
              !showCustomPoll && 
              !showOverlay && 
              !showEffectControls && 
              !showLowerThird && 
              !showIcons && (
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-4">
                    <h4>Timeline Action</h4>
                    <p className="m-0">
                      Customise your videos. Drive your viewers into your sales
                      pipeline using different tools.
                    </p>
                  </div>

                  <div className="video_action_tab">
                    <ul className="list-unstyled m-0 p-0">
                    {(myAccess && (myAccess.includes("2A") || myAccess.includes("8A") || myAccess.includes("8B") || myAccess.includes("1a") || myAccess.includes("5") || myAccess.includes("9A"))) && (
                      <li>
                        <button
                          onClick={() => setShowMeetingLink(true)}
                          className={
                            actionPoint.some(
                              (element) =>
                                element.action_event === "video_meeting"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) =>
                              element.action_event === "video_meeting"
                          )}
                        >
                          <i>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/meeting link.png"
                              }
                              className="img-fluid"
                              alt="img"
                            />
                          </i>
                          CTA Link
                        </button>
                      </li>
                    )}
                      <li>
                        <button
                          onClick={() => {
                            setShowCTA(true)
                            setShowTimingControl(false)
                            setVideoCTAData({
                              ...videoCTAData,
                              actiontime:Number(ytPlayer.start)?format(ytPlayer.start):ytPlayer.start
                            })
                          }}
                          className={
                            actionPoint.some(
                              (element) => element.action_event === "video_cta"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) => element.action_event === "video_cta"
                          )}
                        >
                          <i>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/CTA.png"
                              }
                              className="img-fluid"
                              alt="img"
                            />
                          </i>
                          Custom CTA Link
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => {
                            setShowAnnotation(true)
                            setShowTimingControl(true)
                            setShowActiveTrigger('video_annotation')
                            setAnnotationData({
                              ...annotationData,
                              annotationStartTime:Number(ytPlayer.start)?format(ytPlayer.start):ytPlayer.start,
                              annotationEndTime:format(ytPlayer.end),
                            })
                          }}
                          className={
                            actionPoint.some(
                              (element) =>
                                element.action_event === "video_annotation"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) =>
                              element.action_event === "video_annotation"
                          )}
                        >
                          <i>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/Annovation.png"
                              }
                              className="img-fluid"
                              alt="img"
                            />
                          </i>
                          Link Card
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => {
                            setShowCopyPaste(true)
                            setShowTimingControl(false)
                            setCopyPasteData({
                              ...copyPasteData,
                              CRMstartTime:Number(ytPlayer.start)?format(ytPlayer.start):ytPlayer.start
                            })
                          }}
                          className={
                            actionPoint.some(
                              (element) =>
                                element.action_event === "video_copypaste"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) =>
                              element.action_event === "video_copypaste"
                          )}
                        >
                          <i>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/Copy paste.png"
                              }
                              className="img-fluid"
                              alt="img"
                            />
                          </i>
                          Content Locker Lead Form
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => {
                            setShowLeadGenForm(true)
                            setShowTimingControl(false)
                          }}
                          className={
                            actionPoint.some(
                              (element) =>
                                element.action_event === "video_leadgen"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) =>
                              element.action_event === "video_leadgen"
                          )}
                        >
                          <i>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/lead generation form.png"
                              }
                              className="img-fluid"
                              alt="img"
                            />
                          </i>
                          Trigger Reel Form
                        </button>
                      </li>
                      {(myAccess && (myAccess.includes("2A") || myAccess.includes("8A") || myAccess.includes("8B") || myAccess.includes("1a") || myAccess.includes("5") || myAccess.includes("9A"))) && (
                      <li>
                        <button
                          onClick={() => {
                            setShowCustomPoll(true)
                            setShowTimingControl(false)
                            setCustPollData({
                              ...custPollData,
                              pollTime:Number(ytPlayer.start)?format(ytPlayer.start):ytPlayer.start
                            })
                          }}
                          className={
                            actionPoint.some(
                              (element) =>
                                element.action_event === "video_custPoll"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) =>
                              element.action_event === "video_custPoll"
                          )}
                        >
                          <i>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/Custom pool.png"
                              }
                              className="img-fluid"
                              alt="img"
                            />
                          </i>
                          CUSTOM POLL
                        </button>
                      </li>
                      )}
                      <li>
                        <button
                          onClick={() => setShowOverlayModal(true)}
                          className={
                            actionPoint.some(
                              (element) =>
                                element.action_event === "video_overlay"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) =>
                              element.action_event === "video_overlay"
                          )}
                        >
                          <i>
                            {/* <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/Custom pool.png"
                              }
                              className="img-fluid"
                              alt="img"
                            /> */}
                            <FaPager className="text-main-color" size={18} />
                          </i>
                          Overlay Template
                        </button>
                      </li>
                      {(myAccess && (myAccess.includes("2a") || myAccess.includes("8A") || myAccess.includes("8B") || myAccess.includes("1a") || myAccess.includes("5") || myAccess.includes("9A"))) && (
                      <li>
                        <button
                          onClick={() => setShowLowerThirdModal(true)}
                          className={
                            actionPoint.some(
                              (element) =>
                                element.action_event === "video_lowerthird"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) =>
                              element.action_event === "video_lowerthird"
                          )}
                        >
                          <i>
                            {/* <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/Custom pool.png"
                              }
                              className="img-fluid"
                              alt="img"
                            /> */}
                            <RiPagesFill 
                              className="text-main-color" 
                              size={18} 
                              style={{transform: "rotateZ(180deg)"}}
                            />
                          </i>
                          Lower Third
                        </button>
                      </li>
                      )}
                      <li>
                        <button
                          onClick={() => setShowIcons(true)}
                          className={
                            actionPoint.some(
                              (element) =>
                                element.action_event === "video_icons"
                            )
                              ? "action-added"
                              : ""
                          }
                          disabled={actionPoint.some(
                            (element) =>
                              element.action_event === "video_icons"
                          )}
                        >
                          <i>
                            {/* <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/Custom pool.png"
                              }
                              className="img-fluid"
                              alt="img"
                            /> */}
                            <MdOutlineInsertEmoticon 
                              className="text-main-color" 
                              size={18} 
                            />
                          </i>
                          Icons
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )
            }
            {showMeetingLink && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>CTA Link</h4>
                    <p className="m-0">Design your own end card</p>
                  </div>

                  <form onSubmit={handleMeetingData}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Full Name</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {videoMeetingData.fullname.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.fullname ? "is-invalid" : ""
                          }`}
                          placeholder="John Smith"
                          onChange={(e) =>
                            setVideoMeetingData({
                              ...videoMeetingData,
                              fullname: e.target.value,
                            })
                          }
                          value={videoMeetingData.fullname}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Designation</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {videoMeetingData.designation.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.designation ? "is-invalid" : ""
                          }`}
                          placeholder="Senior Manager"
                          onChange={(e) =>
                            setVideoMeetingData({
                              ...videoMeetingData,
                              designation: e.target.value,
                            })
                          }
                          value={videoMeetingData.designation}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Button Name</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {videoMeetingData.buttontext.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.buttontext ? "is-invalid" : ""
                          }`}
                          placeholder="Go to Link"
                          onChange={(e) =>
                            setVideoMeetingData({
                              ...videoMeetingData,
                              buttontext: e.target.value,
                            })
                          }
                          value={videoMeetingData.buttontext}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Meeting Link</label>
                      <div className="position-relative">
                        {/* <div className="mlnk_txt position-absolute">15/100</div> */}
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.buttontext ? "is-invalid" : ""
                          }`}
                          placeholder="https://prnt.sc/26gabn8"
                          onChange={(e) =>
                            setVideoMeetingData({
                              ...videoMeetingData,
                              meetingLink: e.target.value,
                            })
                          }
                          value={videoMeetingData.meetingLink}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Button Color</label>
                      {/* <div className="rw">
                                                <a href="#0" className="m-0 colorcode text-decoration-none font12 me-3"><i className="fa fa-square"></i> #FF597E</a>
                                                <a href="#0" className="m-0 link_blue"><i className="fa fa-pencil"></i> Change</a>
                                            </div> */}
                      <input
                        type={"color"}
                        className="form-control"
                        onChange={(e) =>
                          setVideoMeetingData({
                            ...videoMeetingData,
                            buttonColor: e.target.value,
                          })
                        }
                        value={videoMeetingData.buttonColor}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowMeetingLink(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showCTA && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Custom CTA Link</h4>
                    <p className="m-0">
                      Customise your videos. Drive your viewers into your sales
                      pipeline using different tools.
                    </p>
                  </div>

                  <form onSubmit={handleCTAData}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Type</label>
                      <select
                        className="form-control select3 shadow-none textbx2"
                        onChange={(e) =>
                          setVideoCTAData({
                            ...videoCTAData,
                            formtype: e.target.value,
                          })
                        }
                      >
                        <option value="text">Text</option>
                        <option value="image">Image</option>
                      </select>
                    </div>
                    {videoCTAData.formtype && videoCTAData.formtype === "text" && (
                      <div className="form_rw mb-3">
                        <label>Text</label>
                        <input
                          className={`form-control textbx2 border shadow-none mb-4 ${
                            errors && errors.text ? "is-invalid" : ""
                          }`}
                          placeholder="Add your text here"
                          onChange={(e) =>
                            setVideoCTAData({
                              ...videoCTAData,
                              text: e.target.value,
                            })
                          }
                          value={videoCTAData.text}
                        />
                      </div>
                    )}

                    {videoCTAData.formtype &&
                      videoCTAData.formtype === "image" && (
                        <div className="form_rw mb-3">
                          <label>Image</label>
                          <input
                            className={`form-control font12 ${
                              errors && errors.image ? "is-invalid" : ""
                            }`}
                            type="file"
                            onChange={handleImageChange}
                          />
                          {videoCTAData.image && (
                            <img 
                            src={videoCTAData.image} 
                            alt="https://google.com" 
                            className="img-fluid" 
                            style={{width: "50px"}} />
                          )}
                          
                        </div>
                      )}

                    <div className="form_rw mb-3">
                      <label>Link</label>
                      <input
                        type="text"
                        className={`form-control h35  p_holder textbx2 shadow-none ${
                          errors && errors.link ? "is-invalid" : ""
                        }`}
                        placeholder="https://prnt.sc/26gabn8"
                        onChange={(e) =>
                          setVideoCTAData({
                            ...videoCTAData,
                            link: e.target.value,
                          })
                        }
                        value={videoCTAData.link}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>

                      <input
                        className="form-control p_holder textbx2 shadow-none"
                        type="text"
                        placeholder="00:00"
                        value={videoCTAData.actiontime}
                        onChange={(e) =>
                          setVideoCTAData({
                            ...videoCTAData,
                            actiontime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "ctaTime")}
                        onBlur={(e) => handleTimeBlur(e, "ctaTime")}
                        ref={timeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) => handleTimeUpDown(e, "up", "ctaTime")}
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) => handleTimeUpDown(e, "down", "ctaTime")}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={
                          videoCTAData.ctaSkipCheck ? true : false
                        }
                        onChange={(e) =>
                          setVideoCTAData({
                            ...videoCTAData,
                            videoCTAData: !videoCTAData.ctaSkipCheck,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        className="btn btn2 me-2"
                        onClick={() => setShowCTA(false)}
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showAnnotation && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Link Card</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      annotation
                    </p>
                  </div>

                  <form onSubmit={handleAnnotationData}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.annotationText ? "is-invalid" : ""
                        }`}
                        placeholder="Click on this link"
                        onChange={(e) =>
                          setAnnotationData({
                            ...annotationData,
                            annotationText: e.target.value,
                          })
                        }
                        value={annotationData.annotationText}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.annotationLink ? "is-invalid" : ""
                        }`}
                        placeholder="https://prnt.sc/26gabn8"
                        onChange={(e) =>
                          setAnnotationData({
                            ...annotationData,
                            annotationLink: e.target.value,
                          })
                        }
                        value={annotationData.annotationLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.annotationStartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={annotationData.annotationStartTime}
                        onChange={(e) =>
                          setAnnotationData({
                            ...annotationData,
                            annotationStartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "annotationStartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "annotationStartTime")}
                        ref={annoStartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "annotationStartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "annotationStartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.annotationEndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={annotationData.annotationEndTime}
                        onChange={(e) =>
                          setAnnotationData({
                            ...annotationData,
                            annotationEndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "annotationEndTime")}
                        onBlur={(e) => handleTimeBlur(e, "annotationEndTime")}
                        ref={annoEndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "annotationEndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "annotationEndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowAnnotation(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showCopyPaste && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Content Locker Lead Form</h4>
                    <p className="m-0">Embed Content Locker Lead form here</p>
                  </div>

                  <form onSubmit={handleCopyPasteData}>
                    <div className="form_rw mb-3">
                      <label>HTML</label>
                      <textarea
                        className={`form-control textbx2 border shadow-none height100 mb-4 ${
                          errors && errors.CRMHtmlText ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) =>
                          setCopyPasteData({
                            ...copyPasteData,
                            CRMHtmlText: e.target.value,
                          })
                        }
                        value={copyPasteData.CRMHtmlText}
                      ></textarea>
                    </div>

                    <div className="form_rw mb-3">
                      <label>
                        <span>Background Theme</span>
                        <Switch
                          onChange={() =>
                            setCopyPasteData({
                              ...copyPasteData,
                              bgCRMTheme: !copyPasteData.bgCRMTheme,
                            })
                          }
                          checked={copyPasteData.bgCRMTheme}
                          className="react-switch ms-4"
                          uncheckedIcon={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                fontSize: 12,
                                color: "white",
                                padding: 5,
                                fontWeight: 600,
                              }}
                            >
                              Dark
                            </div>
                          }
                          checkedIcon={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                fontSize: 12,
                                color: "white",
                                padding: 5,
                                fontWeight: 600,
                              }}
                            >
                              Light
                            </div>
                          }
                          onColor="#86d3ff"
                          onHandleColor="#2693e6"
                          handleDiameter={30}
                          width={80}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          // height={20}
                        />
                      </label>
                    </div>

                    <div className="form-check mb-3 pastevideo">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={copyPasteData.CRMskipCheck}
                        onChange={(e) =>
                          setCopyPasteData({
                            ...copyPasteData,
                            CRMskipCheck: !copyPasteData.CRMskipCheck,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Skip Video{" "}
                        <i
                          className="fa fa-question-circle"
                          title="Check this box to pause the video with CRM form."
                        ></i>
                      </label>
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>
                        {copyPasteData.CRMskipCheck ? "Time" : "Start Time"}
                      </label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={copyPasteData.CRMstartTime}
                        onChange={(e) =>
                          setCopyPasteData({
                            ...copyPasteData,
                            CRMstartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "CRMstartTime")}
                        onBlur={(e) => handleTimeBlur(e, "CRMstartTime")}
                        ref={CRMstartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "CRMstartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "CRMstartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    {!copyPasteData.CRMskipCheck && (
                      <div className="form_rw mb-3 timer-input d-none">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={copyPasteData.CRMendTime}
                          onChange={(e) =>
                            setCopyPasteData({
                              ...copyPasteData,
                              CRMendTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "CRMendTime")}
                          onBlur={(e) => handleTimeBlur(e, "CRMendTime")}
                          ref={CRMendtimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "CRMendTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "CRMendTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    )}

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowCopyPaste(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1">Apply</button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showLeadGenForm && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Trigger Reel Form</h4>
                    <p className="m-0">
                      Add a custom form to generate leads through your videos.
                    </p>
                  </div>

                  <form onSubmit={handleLeadGenData}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="askphonenumber"
                        checked={leadgenFormData.askphonechk ? true : false}
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            askphonechk: !leadgenFormData.askphonechk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="askphonenumber"
                      >
                        Ask for phone number
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="askcompanyname"
                        checked={leadgenFormData.askcompanychk ? true : false}
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            askcompanychk: !leadgenFormData.askcompanychk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="askcompanyname"
                      >
                        Ask for company name
                      </label>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.headline ? "is-invalid" : ""
                        }`}
                        placeholder="To get exclusive offer"
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            headline: e.target.value,
                          })
                        }
                        value={leadgenFormData.headline}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Note</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="This is note text"
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            note: e.target.value,
                          })
                        }
                        value={leadgenFormData.note}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Button Name</label>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none  mb-4 ${
                          errors && errors.buttonname ? "is-invalid" : ""
                        }`}
                        placeholder="Play"
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            buttonname: e.target.value,
                          })
                        }
                        value={leadgenFormData.buttonname}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input d-none">
                      <label>Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={leadgenFormData.leadgenTime}
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            leadgenTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "leadgenTime")}
                        onBlur={(e) => handleTimeBlur(e, "leadgenTime")}
                        ref={leadgenTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "leadgenTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "leadgenTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    {(autoresponder && autoresponder.length > 0) && (
                      <div className="form_rw mb-3 pt-2">
                        <label>Select AutoResponder </label>
                        <select
                          className="form-control select3 shadow-none textbx2 text-capitalize"
                          onChange={handleResponderChange}
                        >
                          <option value="">Select Autoresponder</option>
                          {(autoresponder && autoresponder.length > 0) && autoresponder.map((responder)=>(
                            <option key={responder.id} value={responder.meta_key}>{responder.meta_key}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    {(activeCampaignLists && activeCampaignLists.length > 0) && (
                      <div className="form_rw mb-3 pt-2">
                      <label>Select List </label>
                      <select
                        className="form-control select3 shadow-none textbx2"
                        onChange={(e)=>setLeadgenFormData({
                            ...leadgenFormData,
                            param1:e.target.value
                          })
                        }
                      >
                        <option value="">Select List</option>
                        {(activeCampaignLists && activeCampaignLists.length > 0) && activeCampaignLists.map((list)=>(
                          <option key={list.id} value={list.id}>{list.name}</option>
                        ))}
                      </select>
                    </div>
                    )}

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={
                          leadgenFormData.leadgenSkipCheck ? true : false
                        }
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            leadgenSkipCheck: !leadgenFormData.leadgenSkipCheck,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowLeadGenForm(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showCustomPoll && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>CUSTOM POLL</h4>
                    <p className="m-0">
                      Activate a poll within your videos for quality research &
                      data collection
                    </p>
                  </div>

                  <form onSubmit={handlePollData}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Question</label>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.question ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) =>
                          setCustPollData({
                            ...custPollData,
                            question: e.target.value,
                          })
                        }
                        value={custPollData.question}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 1</label>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.option1 ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) =>
                          setCustPollData({
                            ...custPollData,
                            option1: e.target.value,
                          })
                        }
                        value={custPollData.option1}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 2</label>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.option2 ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) =>
                          setCustPollData({
                            ...custPollData,
                            option2: e.target.value,
                          })
                        }
                        value={custPollData.option2}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 3</label>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4`}
                        placeholder="Optional"
                        onChange={(e) =>
                          setCustPollData({
                            ...custPollData,
                            option3: e.target.value,
                          })
                        }
                        value={custPollData.option3}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={custPollData.pollTime}
                        onChange={(e) =>
                          setCustPollData({
                            ...custPollData,
                            pollTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "pollTime")}
                        onBlur={(e) => handleTimeBlur(e, "pollTime")}
                        ref={pollTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) => handleTimeUpDown(e, "up", "pollTime")}
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) => handleTimeUpDown(e, "down", "pollTime")}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={custPollData.pollSkipChk ? true : false}
                        onChange={(e) =>
                          setCustPollData({
                            ...custPollData,
                            pollSkipChk: !custPollData.pollSkipChk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowCustomPoll(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showOverlay && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Overlay Template</h4>
                    <p className="m-0">
                      Select Overlay Template
                    </p>
                  </div>
                  <div className="template-list-container">
                    <ul className="list-unstyled m-0 px-4">
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'name_animation')}
                        >
                          
                          Text Overlay
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'text_animation_1')}
                        >
                          
                          Simple Text Animation 1
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'text_animation_2')}
                        >
                          
                          Simple Text Animation 2
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'simple_reveal')}
                        >
                          
                          Simple Reveal Effect
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_bubble')}
                        >
                          
                          Speech Bubble 1
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_thought')}
                        >
                          
                          Speech Bubble Thought
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_bubble_2')}
                        >
                          
                          Preset-Horizontal Wobble
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_bubble_3')}
                        >
                          
                          Speech Bubble 3
                        </button>
                      </li>
                      {/* <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_bubble_4')}
                        >
                          
                          Speech Bubble 4
                        </button>
                      </li> */}
                       <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'border_animation')}
                        >
                          
                          Border Animation
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'border_animation_2')}
                        >
                          
                          Border Animation 2
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="btn_wrap_p pt-3 px-4">
                    <button
                      onClick={() => setShowOverlay(false)}
                      className="btn btn2 me-2"
                    >
                      Cancel
                    </button>
                    <button className="btn btn1" type="submit">
                      Select
                    </button>
                  </div>
                </div>
              </>
            )}

            {showLowerThird && (
              <>
              <div className="vac_aside bg-white p-3 shadow2">
                <div className="video_action_h text-center mb-3">
                  <h4>Lower Third Template</h4>
                  <p className="m-0">
                    Select Lower Third Template
                  </p>
                </div>
                <div className="template-list-container">
                  <ul className="list-unstyled m-0 px-4">
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_1')}
                      >
                        
                        Template 1
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_2')}
                      >
                        
                        Template 2
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_3')}
                      >
                        
                        Template 3
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_4')}
                      >
                        
                        Template 4
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_5')}
                      >
                        
                        Template 5
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="btn_wrap_p pt-3 px-4">
                  <button
                    onClick={() => setShowLowerThird(false)}
                    className="btn btn2 me-2"
                  >
                    Cancel
                  </button>
                  <button className="btn btn1" type="submit">
                    Select
                  </button>
                </div>
              </div>
              </>
            )}

            {showIcons && (
              <div className="vac_aside bg-white p-3 shadow2 element_shape">
                <div className="video_action_h text-center mb-3">
                  <h4>Icons</h4>
                  <p className="m-0">
                    Select type of icon which you want to add on video.
                  </p>
                </div>
                <div className="template-list-container">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingEmoji">
                        <button 
                          className="accordion-button" 
                          type="button" 
                          data-bs-toggle="collapse" 
                          data-bs-target="#collapseOne" 
                          aria-expanded="true" 
                          aria-controls="collapseOne"
                        >
                          Emoji
                        </button>
                      </h2>
                      <div 
                        id="collapseOne" 
                        className="accordion-collapse collapse show" 
                        aria-labelledby="headingOne" 
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <ul className="p-2">
                          
                            {(smiley && smiley.length > 0) && smiley.map((icon,index)=>(
                              <li key={index}>
                                <button className="element_svg" onClick={(e)=>handleEffectSetting(e,icon)}>
                                  <img 
                                    src={process.env.REACT_APP_ICONSLINK+"smiley/show/"+icon} 
                                    alt={icon} 
                                  />
                                </button>
                              </li>
                            ))}
                           
                          </ul>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                </div>
                <div className="btn_wrap_p pt-3">
                  <button
                    onClick={handleCloseShowIcon}
                    className="btn btn2 bg-transparent text-danger"
                  >
                    Cancel
                  </button>
                  {/* <button className="btn btn1" type="submit">
                    Select
                  </button> */}
                </div>
              </div>
            )}

            {showEffectControls && (
              <>
                {(showAnimation && showAnimation.nameAnim) && (
                  <>
                    <div className="vac_aside bg-white p-3 shadow2">
                      <div className="video_action_h text-center mb-3">
                        <h4>{showAnimation.name}</h4>
                        <p className="m-0">Design your own Template</p>
                      </div>

                      <form onSubmit={(e)=>handleEffectData(e,'name_animation')}>
                        <div className="form_rw mb-3 pt-2">
                          <label>Text 1</label>
                          <div className="position-relative">
                            <div className="mlnk_txt position-absolute">
                              {showAnimation.text1.length}/50
                            </div>
                            <input
                              name=""
                              type="text"
                              className={`form-control pe-5 p_holder textbx2 shadow-none ${
                                errors && errors.text1 ? "is-invalid" : ""
                              }`}
                              placeholder="John Smith"
                              onChange={(e) =>
                                setShowAnimation({
                                  ...showAnimation,
                                  text1: e.target.value,
                                })
                              }
                              value={showAnimation.text1}
                            />
                            <div className="dropdown">
                              <button 
                                className="btn btn-secondary dropdown-toggle p-1 rounded" 
                                type="button" 
                                id="dropdownMenuButton1" 
                                data-bs-toggle="dropdown" 
                                aria-expanded="false"
                              >
                                Personalize
                              </button>
                              <ul 
                                className="dropdown-menu" 
                                aria-labelledby="dropdownMenuButton1" 
                                style={{background:"#e7e3e3"}}>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >FIRSTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >LASTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >EMAIL</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >GEOCOUNTRY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >GEOCITY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >GEOSTATE</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >COMPANY</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="row mb-3 g-3">
                          <div className="col">
                            <label htmlFor="inputFontFamily">Select Animation</label>
                            <Select
                              options={animationLists}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={animationLists.filter(
                                (option) =>
                                  option.value === showAnimation.animationType
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, animationType: e.value })
                              }
                            />
                          </div>
                        </div>
                        
                        <div className="row mb-3 g-3">
                          <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  showAnimation.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                              }
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontSize">Font Size</label>
                            <Input
                              type="number"
                              inputClass="form-control textbx2 shadow-none "
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                              }
                              value={showAnimation.text1FontSize}
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontColor">Font Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={showAnimation.text1FontColor}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                              }
                            />
                          </div> 
                        </div>

                        <div className="form_rw mb-3 timer-input">
                        <label>Start Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.startTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              startTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                          onBlur={(e) => handleTimeBlur(e, "startTime")}
                          ref={startTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        </div>

                        <div className="form_rw mb-3 timer-input">
                          <label>End Time</label>
                          <input
                            type="text"
                            className="form-control p_holder textbx2 shadow-none"
                            placeholder="00:00"
                            value={showAnimation.endTime}
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                endTime: e.target.value,
                              })
                            }
                            onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                            onBlur={(e) => handleTimeBlur(e, "endTime")}
                            ref={endTimeRef}
                          />
                          <FaSortDown
                            className="up"
                            onClick={(e) =>
                              handleTimeUpDown(e, "up", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <FaSortUp
                            className="down"
                            onClick={(e) =>
                              handleTimeUpDown(e, "down", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        <div className="btn_wrap_p pt-3">
                          <button
                            onClick={(e) => handleClose(e,'name_animation')}
                            className="btn btn2 me-2"
                          >
                            Cancel
                          </button>
                          <button className="btn btn1" type="submit">
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                )}
                {(showAnimation && showAnimation.textAnim1) && (
                  <>
                    <div className="vac_aside bg-white p-3 shadow2">
                      <div className="video_action_h text-center mb-3">
                        <h4>{showAnimation.name}</h4>
                        <p className="m-0">Design your own Template</p>
                      </div>

                      <form onSubmit={(e)=>handleEffectData(e,'text_animation_1')}>
                        <div className="form_rw mb-3 pt-2">
                          <label>Text 1</label>
                          <div className="position-relative">
                            <div className="mlnk_txt position-absolute">
                              {showAnimation.text1.length}/50
                            </div>
                            <input
                              name=""
                              type="text"
                              className={`form-control pe-5 p_holder textbx2 shadow-none ${
                                errors && errors.text1 ? "is-invalid" : ""
                              }`}
                              placeholder="John Smith"
                              onChange={(e) =>
                                setShowAnimation({
                                  ...showAnimation,
                                  text1: e.target.value,
                                })
                              }
                              value={showAnimation.text1}
                            />
                            <div className="dropdown">
                              <button 
                                className="btn btn-secondary dropdown-toggle p-1 rounded" 
                                type="button" 
                                id="dropdownMenuButton1" 
                                data-bs-toggle="dropdown" 
                                aria-expanded="false"
                              >
                                Personalize
                              </button>
                              <ul 
                                className="dropdown-menu" 
                                aria-labelledby="dropdownMenuButton1" 
                                style={{background:"#e7e3e3"}}>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >FIRSTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >LASTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >EMAIL</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >GEOCOUNTRY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >GEOCITY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >GEOSTATE</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >COMPANY</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="row mb-3 g-3">
                          <div className="col">
                            <label htmlFor="inputFontFamily">Select Animation</label>
                            <Select
                              options={animationLists}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={animationLists.filter(
                                (option) =>
                                  option.value === showAnimation.animationType
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, animationType: e.value })
                              }
                            />
                          </div>
                        </div>
                        
                        <div className="row mb-3 g-3">
                          <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  showAnimation.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                              }
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontSize">Font Size</label>
                            <Input
                              type="number"
                              inputClass="form-control textbx2 shadow-none "
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                              }
                              value={showAnimation.text1FontSize}
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontColor">Font Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={showAnimation.text1FontColor}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                              }
                            />
                          </div> 
                        </div>

                        <div className="form_rw mb-3 timer-input">
                        <label>Start Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.startTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              startTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                          onBlur={(e) => handleTimeBlur(e, "startTime")}
                          ref={startTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        </div>

                        <div className="form_rw mb-3 timer-input">
                          <label>End Time</label>
                          <input
                            type="text"
                            className="form-control p_holder textbx2 shadow-none"
                            placeholder="00:00"
                            value={showAnimation.endTime}
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                endTime: e.target.value,
                              })
                            }
                            onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                            onBlur={(e) => handleTimeBlur(e, "endTime")}
                            ref={endTimeRef}
                          />
                          <FaSortDown
                            className="up"
                            onClick={(e) =>
                              handleTimeUpDown(e, "up", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <FaSortUp
                            className="down"
                            onClick={(e) =>
                              handleTimeUpDown(e, "down", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        <div className="btn_wrap_p pt-3">
                          <button
                            onClick={(e) => handleClose(e,'text_animation_1')}
                            className="btn btn2 me-2"
                          >
                            Cancel
                          </button>
                          <button className="btn btn1" type="submit">
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                )}
                {(showAnimation && showAnimation.textAnim2) && (
                  <>
                    <div className="vac_aside bg-white p-3 shadow2">
                      <div className="video_action_h text-center mb-3">
                        <h4>{showAnimation.name}</h4>
                        <p className="m-0">Design your own Template</p>
                      </div>

                      <form onSubmit={(e)=>handleEffectData(e,'text_animation_2')}>
                        <div className="form_rw mb-3 pt-2">
                          <label>Text 1</label>
                          <div className="position-relative">
                            <div className="mlnk_txt position-absolute">
                              {showAnimation.text1.length}/50
                            </div>
                            <input
                              name=""
                              type="text"
                              className={`form-control pe-5 p_holder textbx2 shadow-none ${
                                errors && errors.text1 ? "is-invalid" : ""
                              }`}
                              placeholder="John Smith"
                              onChange={(e) =>
                                setShowAnimation({
                                  ...showAnimation,
                                  text1: e.target.value,
                                })
                              }
                              value={showAnimation.text1}
                            />
                            <div className="dropdown">
                              <button 
                                className="btn btn-secondary dropdown-toggle p-1 rounded" 
                                type="button" 
                                id="dropdownMenuButton1" 
                                data-bs-toggle="dropdown" 
                                aria-expanded="false"
                              >
                                Personalize
                              </button>
                              <ul 
                                className="dropdown-menu" 
                                aria-labelledby="dropdownMenuButton1" 
                                style={{background:"#e7e3e3"}}>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >FIRSTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >LASTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >EMAIL</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >GEOCOUNTRY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >GEOCITY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >GEOSTATE</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >COMPANY</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="row mb-3 g-3">
                          <div className="col">
                            <label htmlFor="inputFontFamily">Select Animation</label>
                            <Select
                              options={animationLists}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={animationLists.filter(
                                (option) =>
                                  option.value === showAnimation.animationType
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, animationType: e.value })
                              }
                            />
                          </div>
                        </div>
                        
                        <div className="row mb-3 g-3">
                          <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  showAnimation.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                              }
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontSize">Font Size</label>
                            <Input
                              type="number"
                              inputClass="form-control textbx2 shadow-none "
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                              }
                              value={showAnimation.text1FontSize}
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontColor">Font Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={showAnimation.text1FontColor}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                              }
                            />
                          </div> 
                        </div>

                        <div className="form_rw mb-3 timer-input">
                        <label>Start Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.startTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              startTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                          onBlur={(e) => handleTimeBlur(e, "startTime")}
                          ref={startTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        </div>

                        <div className="form_rw mb-3 timer-input">
                          <label>End Time</label>
                          <input
                            type="text"
                            className="form-control p_holder textbx2 shadow-none"
                            placeholder="00:00"
                            value={showAnimation.endTime}
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                endTime: e.target.value,
                              })
                            }
                            onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                            onBlur={(e) => handleTimeBlur(e, "endTime")}
                            ref={endTimeRef}
                          />
                          <FaSortDown
                            className="up"
                            onClick={(e) =>
                              handleTimeUpDown(e, "up", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <FaSortUp
                            className="down"
                            onClick={(e) =>
                              handleTimeUpDown(e, "down", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        <div className="btn_wrap_p pt-3">
                          <button
                            onClick={(e) => handleClose(e,'text_animation_2')}
                            className="btn btn2 me-2"
                          >
                            Cancel
                          </button>
                          <button className="btn btn1" type="submit">
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                )}
                {(showAnimation && showAnimation.simpleRevealShow) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <form onSubmit={(e)=>handleEffectData(e,'simple_reveal')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/50
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                          <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                  >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 ">
                        <label>Text 2</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text2.length}/50
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text2 ? "is-invalid" : ""
                            }`}
                            placeholder="Senior Manager"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text2: e.target.value,
                              })
                            }
                            value={showAnimation.text2}
                          />
                          <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          {/* <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.bgTheme}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, bgTheme: e.target.value })
                            }
                            
                          /> */}
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>
                      <div className="btn_wrap_p pt-3">
                        <button
                          onClick={(e) => handleClose(e,'simple_reveal')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.speechBubble) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <form onSubmit={(e)=>handleEffectData(e,'speech_bubble')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>


                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                         onClick={(e) => handleClose(e,'speech_bubble')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.speechBubble2) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <form onSubmit={(e)=>handleEffectData(e,'speech_bubble_2')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Quote</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                      </div>

                      <div className="form_rw mb-3 pt-2">
                        <label>Author</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text2.length}/20
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text2 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text2: e.target.value,
                              })
                            }
                            value={showAnimation.text2}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                      </div>

                      <div className="row g-3">
                        
                        <div className="col">
                          <label htmlFor="inputFontColor">Bubble Background Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                         onClick={(e) => handleClose(e,'speech_bubble_2')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.speechBubble3) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <form onSubmit={(e)=>handleEffectData(e,'speech_bubble_3')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>


                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                         onClick={(e) => handleClose(e,'speech_bubble_3')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.speechThought) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <form onSubmit={(e)=>handleEffectData(e,'speech_thought')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="Please Enter Your Message"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                          onClick={(e) => handleClose(e,'speech_thought')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.borderAnim) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <form onSubmit={(e)=>handleEffectData(e,'border_animation')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="Please Enter Your Message"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>
                      
                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                          
                        </div>
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                          onClick={(e) => handleClose(e,'border_animation')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.borderAnim2) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <form onSubmit={(e)=>handleEffectData(e,'border_animation_2')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="Please Enter Your Message"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Bg Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                          onClick={(e) => handleClose(e,'border_animation_2')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation1) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_1')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Text 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text2.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text2 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text2: e.target.value,
                            })
                          }
                          value={showAnimation.text2}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                    </div>


                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                   
                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_1')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation2) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_2')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Text 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text2.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text2 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text2: e.target.value,
                            })
                          }
                          value={showAnimation.text2}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  
                        
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_2')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation3) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_3')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>


                    <div className="form_rw mb-3 pt-2">
                      <label>Text 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text2.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text2 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text2: e.target.value,
                            })
                          }
                          value={showAnimation.text2}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  
                        
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_3')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation4) && (
                  <div className="vac_aside bg-white p-3 shadow2">  
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_4')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  

                      <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                        
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                  

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_4')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation5) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_5')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Text 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text2.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text2 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text2: e.target.value,
                            })
                          }
                          value={showAnimation.text2}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  

                      <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                        
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_5')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.smiley) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    {/* <p className="m-0">Design your own Template</p> */}
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,"emoji_content")}>
                   
                    <div className="form_rw mb-3 pt-2">
                      <label>Smiley Icons</label>
                      <div className="position-relative">
                        <div className="smileyEditor">
                          {(showAnimation.smileyContent && showAnimation.smileyContent.length > 0) && showAnimation.smileyContent.map((icon,index)=>(
                            <div className="position-relative p-2 svgIcon-container" key={icon+index}>
                              <img 
                                src={process.env.REACT_APP_ICONSLINK+"smiley/show/"+icon} 
                                alt={showAnimation.smileyContent} 
                                style={{height:"45px",width:"45px"}}
                                className="svgIcon"
                              />
                              <button 
                                onClick={(e)=>handleDeleteIcon(e,icon)}
                                className="btn text-danger iconDelete"
                              ><FaTimesCircle /></button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,"emoji_content")}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                
              </>
            )}
          </div>

          <div className="col-xl-7 col-lg-7 col-md-12">
            <div className="v_new_bx position-relative mb-3">
              <div className="video_a_r1 vidAmaze-player">
                {/* <img src={process.env.PUBLIC_URL + "/assets/images/video_pic_1.png"} className=" w-100" alt="img" /> */}
                {campaign_data && (campaign_data.video_type === "upload" || campaign_data.video_type === "cust_upload") && (
                  <>
                     <ReactPlayer 
                      url={ytPlayer.url} 
                      className="w-100 react-player"
                      height="390px"
                      id="video_player"
                      playing={ytPlayer.playing}
                      onPlay={()=>setYtPlayer({...ytPlayer,playing:true})}
                      onPause={()=>setYtPlayer({...ytPlayer,playing:false})}
                      onProgress={handleProgress}
                      onDuration={handleDuration}
                      muted={ytPlayer.muted}
                      volume={ytPlayer.volume}
                      ref={ytPlayerRef}
                      onError={e => console.log('onError', e)}
                    />
                  </>
                )}
                {campaign_data && campaign_data.video_type === "embed" && (
                  <>
                  <ReactPlayer 
                    url={ytPlayer.url} 
                    // url={`https://www.youtube.com/watch?v=Q3FZv7fZi48?start=30&end=180`}
                    className="w-100"
                    height="390px"
                    id="video_player"
                    playing={ytPlayer.playing}
                    onPlay={()=>setYtPlayer({...ytPlayer,playing:true})}
                    onPause={()=>setYtPlayer({...ytPlayer,playing:false})}
                    onProgress={handleProgress}
                    onDuration={handleDuration}
                    muted={ytPlayer.muted}
                    volume={ytPlayer.volume}
                    ref={ytPlayerRef}
                    onEnded={()=>setYtPlayer({...ytPlayer,playing:false})}
                  />
                  </>
                )}
                <div className="player-controls-container player-controls-inside showing-controls">
                  <button
                    className="border-0 bg-transparent play-pause-button"
                    id="pauseAndPlayBtn"
                    onClick={()=>setYtPlayer({...ytPlayer,playing:!ytPlayer.playing})}
                  >
                    {!ytPlayer.playing ? (
                      <FaPlay className="text-white" />
                    ) : (
                      <FaPause className="text-white" />
                    )}
                  </button>
                  <div className="cta-indicator">
                    <div
                      id="ctaIndicatorInner"
                      className="cta-indicator-inner"
                    >
                      {actionPoint &&
                        actionPoint.length > 0 &&
                        actionPoint.map((elem, index) => (
                          <div key={index}>
                            {elem.action_event === "video_cta" && (
                              <span
                                className="call-to-action-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_leadgen" && (
                              <span
                                className="leadgen-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_annotation" && (
                              <span
                                className="annotation-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_copypaste" && (
                              <span
                                className="copypaste-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_custPoll" && (
                              <span
                                className="custpoll-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_meeting" && (
                              <span
                                className="end-card-marker"
                                style={{ left: "99%" }}
                              ></span>
                            )}

                            {(elem.action_event === "simple_reveal" || 
                              elem.action_event === "speech_bubble" || 
                              elem.action_event === "speech_bubble_2" || 
                              elem.action_event === "speech_bubble_3" || 
                              elem.action_event === "speech_bubble_4" || 
                              elem.action_event === "speech_thought" || 
                              elem.action_event === "border_animation" || 
                              elem.action_event === "border_animation_2" || 
                              elem.action_event === "lt_animation_1" || 
                              elem.action_event === "lt_animation_2" || 
                              elem.action_event === "lt_animation_3" || 
                              elem.action_event === "lt_animation_4" || 
                              elem.action_event === "lt_animation_5" || 
                              elem.action_event === "text_animation_1" || 
                              elem.action_event === "text_animation_2" || 
                              elem.action_event === "name_animation") && (
                              <span
                                className="end-card-marker"
                                style={{ left: getActioTime(elem.action_time) }}
                                title={elem.action_event}
                              ></span>
                            )}

                            {elem.action_event === "emoji_content" && (
                              <span
                                className="emoji-action-marker"
                                style={{ left: getActioTime(elem.action_time) }}
                              ></span>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                  <div
                    id="chapterIndicatorId"
                    className="hp-indicator hide"
                  ></div>
                  <div className="player-progress">
                    <input
                      type="range"
                      // allowCross={true}
                      min={0}
                      max={1}
                      value={ytPlayer.played}
                      // value={ytPlayer.playedSeconds/ytPlayer.duration}
                      onMouseDown={handleSeekMouseDown}
                      onChange={handleSeekChange}
                      onMouseUp={handleSeekMouseUp}
                      step="any"
                      className="player-progress-input"
                    />
                    
                  </div>
                  <span className="player-currenttime">
                    {" "}
                    {format(Math.round(ytPlayer.duration * ytPlayer.played))}
                    /{" "}
                    {format(Math.round(ytPlayer.duration))}
                  </span>
                  <div className="actions-container pull-right">
                    <span
                      className="player-audio controls-btn"
                      id="videoVolumeBtn"
                    >
                      {!ytPlayer.muted ? (
                        <HiVolumeUp
                          className="text-white player-volume"
                          onClick={toggleYtMute}
                        />
                      ) : (
                        <HiVolumeOff
                          className="text-white player-volume"
                          onClick={toggleYtMute}
                        />
                      )}
                      <div className="volume-container">
                        <Slider
                          vertical
                          min={0}
                          max={1}
                          step={0.1}
                          onChange={handleYtAudioLevel}
                          defaultValue={ytPlayer.muted ? 0 : ytPlayer.volume}
                          value={
                            ytPlayer.muted ? 0 : ytPlayer.volume
                          }
                        />
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div className="overlay-container-preview">
                {showMeetingLink && (
                  <div className="popup_sml d-flex align-items-center justify-content-center rounded">
                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto text-center">
                        <p className="text-white text-center fw600 m-0 mb-4">
                          {videoMeetingData.fullname}
                        </p>
                        <p className="text-white text-center fw600 m-0 mb-4">
                          {videoMeetingData.designation}
                        </p>
                        <p></p>
                        <a
                          href={videoMeetingData.meetingLink}
                          className="btn mt-4"
                          style={{
                            backgroundColor: videoMeetingData.buttonColor,
                          }}
                        >
                          {videoMeetingData.buttontext}
                        </a>
                      </div>
                    </div>
                  </div>
                )}
                {showCTA && (
                  <div className="popup_sml d-flex align-items-center justify-content-center rounded">
                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto text-center">
                        {videoCTAData.formtype === "text" && (
                          <a
                            href={videoCTAData.link}
                            className="text-white text-center h2 fw600 m-0 d-block"
                          >
                            {videoCTAData.text}
                          </a>
                        )}
                        {videoCTAData.formtype === "image" && (
                          <a
                            href={videoCTAData.link}
                            className="text-white text-center fw600 m-0"
                          >
                            <img
                              src={videoCTAData.image}
                              alt={videoCTAData.link}
                              className="img-fluid"
                              style={{width: "192px"}}
                            />
                          </a>
                        )}
                        {videoCTAData.ctaSkipCheck && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowCTA(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                            
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                  
                      </div>
                    </div>
                  </div>
                )}
                {showAnnotation &&
                  (annotationData.annotationLink.length > 0 ||
                    annotationData.annotationText.length > 0) && (
                    <div className="cta-player-annotation ">
                      <a
                        className="cta-player-annotation-link"
                        href={annotationData.annotationLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <label
                          className="cta-annotation-label"
                          id="ctaPlayerAnnotationLbl"
                        >
                          {annotationData.annotationText}
                        </label>
                      </a>
                    </div>
                  )}
                {showCopyPaste && (
                  <div
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{
                      background: `${
                        copyPasteData.bgCRMTheme ? "#000000b3" : "#ffffffb3"
                      }`,
                    }}
                  >
                    <div
                      className="crmForm"
                      dangerouslySetInnerHTML={{
                        __html: copyPasteData.CRMHtmlText,
                      }}
                    ></div>
                    {copyPasteData.CRMskipCheck && (
                      <button
                        className={`cta-player-skip ${
                          !copyPasteData.bgCRMTheme ? "cta-skip-inverse" : ""
                        }`}
                        onClick={(e)=>{
                          setShowCopyPaste(false)
                          setYtPlayer({...ytPlayer,playing:true})
                          setShowPreviewElem(true)
                        }}
                      >
                        Skip <FaPlay />
                      </button>
                    )}
                  </div>
                )}
                {showLeadGenForm && (
                  <div className="popup_sml d-flex align-items-center">
                    <div className="row">
                      <div className="col-xl-7 col-lg-8 col-md-10 m-auto">
                        <h4 className="text-white text-center fw600">
                          {leadgenFormData.headline}
                        </h4>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="text"
                              className="form-control p_holder textbx2 shadow-none h35 border-0"
                              placeholder="First Name"
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <input
                              type="text"
                              className="form-control p_holder textbx2 shadow-none h35 border-0"
                              placeholder="Last Name"
                            />
                          </div>
                          {leadgenFormData.askcompanychk &&
                            leadgenFormData.askphonechk && (
                              <>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Phone Number"
                                  />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Company Name"
                                  />
                                </div>
                                <div className="col-md-12 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Email address"
                                  />
                                </div>
                              </>
                            )}
                          {leadgenFormData.askcompanychk &&
                            !leadgenFormData.askphonechk && (
                              <>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Company Name"
                                  />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Email address"
                                  />
                                </div>
                              </>
                            )}
                          {!leadgenFormData.askcompanychk &&
                            leadgenFormData.askphonechk && (
                              <>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Phone Number"
                                  />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Email address"
                                  />
                                </div>
                              </>
                            )}
                          {!leadgenFormData.askcompanychk &&
                            !leadgenFormData.askphonechk && (
                              <div className="col-md-12 mb-3">
                                <input
                                  type="text"
                                  className="form-control p_holder textbx2 shadow-none h35 border-0"
                                  placeholder="Email address"
                                />
                              </div>
                            )}
                          <div className="col-md-12 mb-3 text-center">
                            <input
                              type="button"
                              className="btn btn1 min_w150"
                              value={leadgenFormData.buttonname}
                            />
                          </div>
                          <p className="text-white h6 text-center">
                            {leadgenFormData.note}
                          </p>
                        </div>
                        {leadgenFormData.leadgenSkipCheck && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowLeadGenForm(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {showCustomPoll && (
                  <div className="popup_sml d-flex align-items-center justify-content-center rounded">
                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto">
                        <h6 className="text-white text-center fw600 font17 mb-3">
                          {custPollData.question}
                        </h6>
                        <div className="row">
                          <div className={`col-md-12 mb-3 text-center`}>
                            <input
                              type="button"
                              className="btn btn1 w-100 shadow-none rounded-pill"
                              value={custPollData.option1}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className={`col-md-12 mb-3 text-center`}>
                            <input
                              type="button"
                              className="btn btn1 lightbtn w-100 shadow-none rounded-pill"
                              value={custPollData.option2}
                            />
                          </div>
                        </div>
                        {custPollData.option3 && (
                          <div className="row">
                            <div className="col-md-12 text-center mb-3">
                              <input
                                type="button"
                                className="btn btn1 lightbtn w-100 shadow-none rounded-pill"
                                value={custPollData.option3}
                              />
                            </div>
                          </div>
                        )}

                        {custPollData.pollSkipChk && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowCustomPoll(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {(showAnimation && showAnimation.nameAnim) && (
                  <div className={`popup_sml d-flex align-items-center justify-content-center rounded bg-transparent animate__animated ${showAnimation.animationType}`}>
                    
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="name-animation-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={100}
                          minHeight={50}
                          maxWidth={520}
                          maxHeight={310}
                        >
                          <div className="name-animation-container">
                            <span 
                              style={{
                                fontSize:showAnimation.text1FontSize+"px",
                                fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                color:showAnimation.text1FontColor
                              }}
                            >
                              {showAnimation.text1}
                            </span>
                          </div>
                        </Resizable>
                      </div>
                    </Draggable> 
                  </div>
                )}  
                {(showAnimation && showAnimation.textAnim1) && (
                  <div className={`popup_sml d-flex align-items-center justify-content-center rounded bg-transparent animate__animated ${showAnimation.animationType}`}>
                    
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="text-animation-1-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={100}
                          minHeight={50}
                          maxWidth={520}
                          maxHeight={310}
                        >
                          <div className="text-animation-1-container">
                            <span 
                              style={{
                                fontSize:showAnimation.text1FontSize+"px",
                                fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                color:showAnimation.text1FontColor
                              }}
                            >
                              {showAnimation.text1}
                            </span>
                          </div>
                        </Resizable>
                      </div>
                    </Draggable> 
                  </div>
                )}  
                {(showAnimation && showAnimation.textAnim2) && (
                  <div className={`popup_sml d-flex align-items-center justify-content-center rounded bg-transparent animate__animated ${showAnimation.animationType}`}>
                    
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="text-animation-2-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={100}
                          minHeight={50}
                          maxWidth={520}
                          maxHeight={310}
                        >
                          <div className="text-animation-2-container">
                            <span 
                              style={{
                                fontSize:showAnimation.text1FontSize+"px",
                                fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                color:showAnimation.text1FontColor
                              }}
                            >
                              {showAnimation.text1}
                            </span>
                          </div>
                        </Resizable>
                      </div>
                    </Draggable> 
                  </div>
                )}  
                {(showAnimation && showAnimation.simpleRevealShow) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded" 
                    style={{background:`rgba(${showAnimation.bgTheme})`}}>
                    <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                      <div className="simple-reveal-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={200}
                          minHeight={180}
                          maxWidth={510}
                          maxHeight={310}
                        >
                          <div className="simple-reveal-container">
                            <div className="effect-wrap">
                              <div>
                                <h1 
                                  className="effect-block" 
                                  style={{
                                    "--background": showAnimation.text1BgColor,
                                    fontSize:showAnimation.text1FontSize+"px",
                                    fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                    color:showAnimation.text1FontColor
                                  }}
                                >
                                  <span>{showAnimation.text1}</span>
                                </h1>
                              <h1 
                                className="effect-block" 
                                id="another" 
                                style={{
                                  "--background": showAnimation.text2BgColor,
                                  fontSize:showAnimation.text2FontSize+"px",
                                  fontFamily:showAnimation.text2FontFamily+",sans-serif",
                                  color:showAnimation.text2FontColor
                                }}
                              >
                                <span>{showAnimation.text2}</span>
                              </h1>
                              </div>
                            </div>
                          </div>
                        </Resizable>
                      </div>
                    </Draggable>
                  </div>
                )}  

                {(showAnimation && showAnimation.speechBubble) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                        <div className="speech-bubble-container-resize">
                          <Resizable
                            style={style}
                            size={{ width, height }}
                            onResizeStop={(e, direction, ref, d) => {
                              setWidth(width + d.width);
                              setHeight(height + d.height);
                              setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                            }}
                            minWidth={200}
                            minHeight={180}
                            maxWidth={510}
                            maxHeight={310}
                          >
                            <div className="speech-bubble-container">
                              <p 
                                className="bubble speech"
                                style={{
                                  "--border": showAnimation.text1BgColor,
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >
                                {showAnimation.text1}
                              </p>
                            </div>
                          </Resizable>
                        </div>
                      </Draggable>
                    
                  </div>
                )}  

                {(showAnimation && showAnimation.speechBubble2) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="speech-bubble-2-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={200}
                          minHeight={120}
                          maxWidth={510}
                          maxHeight={310}
                        >
                          <div className="speech-bubble-2-container">
                            <div 
                              className="l-quote quote"
                              style={{
                                background:showAnimation.text1BgColor,
                                "--background": showAnimation.text1BgColor
                              }}
                            >
                              <blockquote
                                style={{
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >
                                <p>{showAnimation.text1}</p>
                              </blockquote>
                              <cite
                                style={{
                                  fontSize:showAnimation.text2FontSize+"px",
                                  fontFamily:showAnimation.text2FontFamily+",sans-serif",
                                  color:showAnimation.text2FontColor
                                }}
                              >{showAnimation.text2}</cite>
                            </div>
                          </div>
                        </Resizable>
                        </div>
                    </Draggable>
                  </div>
                )}            

                {(showAnimation && showAnimation.speechBubble3) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                        <div className="speech-bubble-3-container-resize">
                          <Resizable
                            style={style}
                            size={{ width, height }}
                            onResizeStop={(e, direction, ref, d) => {
                              setWidth(width + d.width);
                              setHeight(height + d.height);
                              setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                            }}
                            minWidth={200}
                            minHeight={120}
                            maxWidth={510}
                            maxHeight={310}
                          >
                            <div className="speech-bubble-3-container">
                              <div 
                                className='speech-bubble'
                                style={{
                                  "--background": showAnimation.text1BgColor,
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >{showAnimation.text1}</div>
                            </div>
                          </Resizable>
                        </div>
                      </Draggable>
                  </div>
                )}              
            
                {(showAnimation && showAnimation.speechThought) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                        <div className="speech-thought-container-resize">
                          <Resizable
                            style={style}
                            size={{ width, height }}
                            onResizeStop={(e, direction, ref, d) => {
                              setWidth(width + d.width);
                              setHeight(height + d.height);
                              setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                            }}
                            minWidth={200}
                            minHeight={180}
                            maxWidth={510}
                            maxHeight={310}
                          >
                            <div className="speech-thought-container">
                              <p 
                                className="bubble thought"
                                style={{
                                  "--border": showAnimation.text1BgColor,
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >
                                {showAnimation.text1}
                              </p>
                            </div>
                          </Resizable>
                        </div>
                      </Draggable>
                  </div>
                )}

                {(showAnimation && showAnimation.borderAnim) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                        <div className="border-animation-container-resize">
                          <Resizable
                            style={style}
                            size={{ width, height }}
                            onResizeStop={(e, direction, ref, d) => {
                              setWidth(width + d.width);
                              setHeight(height + d.height);
                              setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                            }}
                            minWidth={150}
                            minHeight={100}
                            maxWidth={510}
                            maxHeight={310}
                          >
                            <div className="border-animation-container">
                              <div 
                                className="border-animation"
                                style={{
                                  "--color": showAnimation.text2BgColor,
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >
                                <div 
                                  className="border-animation__inner"
                                  style={{background:showAnimation.text1}}
                                >{showAnimation.text1}</div>
                              </div>
                            </div>
                          </Resizable>
                        </div>
                      </Draggable>
                  </div>
                )}

                {(showAnimation && showAnimation.borderAnim2) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="border-animation-2-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={200}
                          minHeight={100}
                          maxWidth={510}
                          maxHeight={310}
                        >
                        <div className="border-animation-2-container">
                          <div 
                            className="box"
                            style={{
                              background:showAnimation.text2BgColor,
                            }}
                          >
                            <div 
                              className="contentAnim"
                              style={{
                                background: showAnimation.text1BgColor,
                              }}
                            >
                              <h1 style={{
                                fontSize:showAnimation.text1FontSize+"px",
                                color:showAnimation.text1FontColor,
                                fontFamily:showAnimation.text1FontFamily+",sans-serif",
                              }}>
                                {showAnimation.text1}
                              </h1> 
                            </div>
                          </div>
                        </div>
                        </Resizable>
                      </div>
                    </Draggable>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation1) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-2 rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <div id="animation-1" className="animation ms-5">
                      <div 
                        className="red"
                        style={{color:showAnimation.text2BgColor}}
                      >/</div>
                      <div 
                        className="white light mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text1}</div>
                      </div>
                      <div 
                        className="white light mask"
                        style={{
                          fontSize:showAnimation.text2FontSize+"px",
                          color:showAnimation.text2FontColor,
                          fontFamily:showAnimation.text2FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text2}</div>
                      </div>
                    </div>
                  </div>
                )}             

                {(showAnimation && showAnimation.ltAnimation2) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-2 rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <div id="animation-2" className="animation">
                      <div 
                        className="red bold arimo mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div className="p-2">{showAnimation.text1}</div>
                      </div>
                      <div 
                        className="white light mask"
                        style={{
                          fontSize:showAnimation.text2FontSize+"px",
                          color:showAnimation.text2FontColor,
                          fontFamily:showAnimation.text2FontFamily+",sans-serif",
                        }}
                      >
                        <div className="px-2">{showAnimation.text2}</div>
                      </div>
                    </div>
                  </div>
                )}    

                {(showAnimation && showAnimation.ltAnimation3) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-2 rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <div id="animation-3" className="animation">
                      <div 
                        className="white light mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text1}</div>
                      </div>
                      <div 
                        className="red bold arimo mask"
                        style={{
                          fontSize:showAnimation.text2FontSize+"px",
                          color:showAnimation.text2FontColor,
                          fontFamily:showAnimation.text2FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text2}</div>
                      </div>
                    </div>
                  </div>
                )}      

                {(showAnimation && showAnimation.ltAnimation4) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-2 rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <div id="animation-4" className="animation">
                      <div 
                        className="white bold arimo mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div className="p-2">{showAnimation.text1}</div>
                      </div>
                      <div className="mask"><div style={{background:showAnimation.text2BgColor}}></div></div>
                    </div>
                  </div>
                )}   

                {(showAnimation && showAnimation.ltAnimation5) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-3 rounded"
                    style={{
                      background:`rgba(${showAnimation.bgTheme})`,
                      "--border-color":showAnimation.text2BgColor
                    }}
                  >
                    <div id="animation-5" className="animation">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                        <defs>
                          <clipPath id="mask-bottom-right">
                            <rect className="clip-path" x="70%" y="0" width="30%" height="100%"/>
                          </clipPath>
                          <clipPath id="mask-top">
                            <rect className="clip-path" x="0" y="0" width="100%" height="100%"/>
                          </clipPath>
                          <clipPath id="mask-bottom-left">
                            <rect className="clip-path" x="0" y="0" width="30%" height="100%"/>
                          </clipPath>
                        </defs>
                        
                        <line className="bottom-right" x1="70%" y1="100%" x2="100%" y2="100%"/>
                        <line className="right" x1="100%" y1="0" x2="100%" y2="100%"/>
                        <line className="top" x1="0" y1="0" x2="100%" y2="0"/>
                        <line className="left" x1="0" y1="0" x2="0" y2="100%"/>
                        <line className="bottom-left" x1="0" y1="100%" x2="30%" y2="100%"/>
                      </svg>
                      <div 
                        className="white bold arimo mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text1}</div>
                      </div>
                      <div 
                        className="white mask"
                        style={{
                          fontSize:showAnimation.text2FontSize+"px",
                          color:showAnimation.text2FontColor,
                          fontFamily:showAnimation.text2FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text2}</div>
                      </div>
                    </div>
                  </div>
                )}   

                {(showAnimation && showAnimation.smiley) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded bg-transparent"
                  >
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="icon-smiley-container-resize">
                        <Resizable
                          style={{border:"dashed 2px #ddd"}}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={50}
                          minHeight={50}
                          maxWidth={510}
                          maxHeight={310}
                        >
                        <div className="icon-smiley-container">
                          <div className="d-flex align-items-center justify-content-center">
                          {(showAnimation.smileyContent && showAnimation.smileyContent.length > 0) && showAnimation.smileyContent.map((icon,index)=>(
                            
                            <img 
                              src={process.env.REACT_APP_ICONSLINK+"smiley/show/"+icon}
                              alt={icon}
                              style={{
                                width: ((width-10)/showAnimation.smileyContent.length)+"px",
                                height: height+"px",
                              }}
                              key={icon+index}
                            />
                            
                          ))}
                          </div>
                        </div>
                        </Resizable>
                      </div>
                    </Draggable>
                  </div>
                )}
              </div>        
            </div>
            <div className="v_action_r_b">
              {showTimingControl && (
                <>
                <div className="time-set-container mb-4">
                  <Slider
                    range
                    allowCross={false}
                    defaultValue={[(
                      ((ytPlayer.playedSeconds) /
                        (ytPlayer.duration)) *
                        100 
                    ),(
                      (((ytPlayer.playedSeconds) + 12) /
                        (ytPlayer.duration)) *
                        100
                    )]}
                    value={[(
                      ((Number(ytPlayer.start)?ytPlayer.start:getSeconds(ytPlayer.start)) /
                        (ytPlayer.duration)) *
                        100 
                    ),(
                      ((Number(ytPlayer.end)?ytPlayer.end:getSeconds(ytPlayer.end)) /
                        (ytPlayer.duration)) *
                        100
                    )]}
                    onAfterChange={handlePlayAfter}
                    onChange={handleTriggerTime}
                    draggableTrack={true}
                    tipFormatter={value => `${format(((value / 100) * ytPlayer.duration))}`}
                  />  
                </div>

                <div className="row">
                  <div className="col d-flex justify-content-start">
                    <button className="btn py-1" onClick={handlePlayBetween}>
                    {!ytPlayer.playing ? (
                      <FaPlay />
                    ) : (
                      <FaPause />
                    )} Play in Between 
                    </button>
                  </div>
                </div>
                
                <div className="timer-container">
                  <div className="row">
                    <div className="time-before-container col d-flex justify-content-start">
                      <div className="select-before-time-element">
                        <div className="arrow right-arrow"></div>
                        <div className="form_rw mb-3 timer-input">
                            <label>Start Time</label>
                            <input
                              type="text"
                              className="form-control p_holder shadow-none"
                              placeholder="00:00"
                              value={Number(ytPlayer.start)?format(ytPlayer.start):((ytPlayer.start === 0 || ytPlayer.start === '0')?"00:00":ytPlayer.start)}
                              onChange={(e) =>
                                setYtPlayer({
                                  ...ytPlayer,
                                  start: e.target.value,
                                })
                              }
                              onKeyUp={(e) => handleTimeKeyUp(e, "setStartTime")}
                              onBlur={(e) => handleTimeBlur(e, "setStartTime")}
                              ref={setStartTimeRef}
                            />
                            <FaSortDown
                              className="up"
                              onClick={(e) =>
                                handleTimeUpDown(e, "up", "setStartTime")
                              }
                              style={{ cursor: "pointer" }}
                            />
                            <FaSortUp
                              className="down"
                              onClick={(e) =>
                                handleTimeUpDown(e, "down", "setStartTime")
                              }
                              style={{ cursor: "pointer" }}
                            />
                        </div>
                      </div>
                    </div>
                    <div className="time-after-container col d-flex justify-content-end">
                      <div className="select-after-time-element">
                        <div className="arrow right-arrow"></div>
                        <div className="form_rw mb-3 timer-input">
                            <label>End Time</label>
                            <input
                              type="text"
                              className="form-control p_holder shadow-none"
                              placeholder="00:00"
                              value={Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end}
                              onChange={(e) =>
                                setYtPlayer({
                                  ...ytPlayer,
                                  end: e.target.value,
                                })
                              }
                              onKeyUp={(e) => handleTimeKeyUp(e, "setEndTime")}
                              onBlur={(e) => handleTimeBlur(e, "setEndTime")}
                              ref={setEndTimeRef}
                            />
                            <FaSortDown
                              className="up"
                              onClick={(e) =>
                                handleTimeUpDown(e, "up", "setEndTime")
                              }
                              style={{ cursor: "pointer" }}
                            />
                            <FaSortUp
                              className="down"
                              onClick={(e) =>
                                handleTimeUpDown(e, "down", "setEndTime")
                              }
                              style={{ cursor: "pointer" }}
                            />
                        </div>
                      </div>
                    </div>
                    <div className="col d-flex justify-content-start align-items-center mt-2">
                      <div className="select-after-time-element">
                        <button className="btn" onClick={handleSetTime}>Set Time</button>
                      </div>
                    </div>
                  
                  </div>
                </div>
                </>
              )}
              <ul
                className={`m-0 p-0 list-unstyled ${
                  actionPoint.length > 0 ? "timeline" : "notimeline"
                }`}
              >
                {actionPoint && actionPoint.length === 0 && (
                  <li className="d-flex align-items-center justify-content-between">
                    <div className="cl_va_1">
                      <div className="radio_grey"></div>
                    </div>

                    <div className="cl_va_2 d-flex align-items-center justify-content-between position-relative">
                      <div className="cl_sml_v_a d-flex align-items-center">
                        <i>
                          <FaRegClock />
                        </i>
                        <div className="vtxt">
                          <h6 className="m-0">Timeline is empty</h6>
                          <p className="m-0">
                            No timeline actions created yet.
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                )}

                {actionPoint &&
                  actionPoint.length > 0 &&
                  actionPoint
                    .sort((a, b) => (a.action_time > b.action_time ? 1 : -1))
                    .map((elem, index) => (
                      // (elem.action_event === 'video_leadgen') && (
                      <li
                        className="d-flex align-items-center justify-content-between"
                        key={index}
                      >
                        <div className="cl_va_1">
                          {elem.action_event === "video_cta" && (
                            <div className="radio_yellow"></div>
                          )}
                          {elem.action_event === "video_meeting" && (
                            <div className="radio_primary"></div>
                          )}
                          {elem.action_event === "video_leadgen" && (
                            <div className="radio_green"></div>
                          )}
                          {elem.action_event === "video_annotation" && (
                            <div className="radio_info"></div>
                          )}
                          {elem.action_event === "video_copypaste" && (
                            <div className="radio_red"></div>
                          )}
                          {elem.action_event === "video_custPoll" && (
                            <div className="radio_pink"></div>
                          )}
                          {elem.action_event === "emoji_content" && (
                            <div className="radio_yellow"></div>
                          )}
                          {(elem.action_event === "simple_reveal" || 
                          elem.action_event === "speech_bubble" || 
                          elem.action_event === "speech_bubble_2" || 
                          elem.action_event === "speech_bubble_3" || 
                          elem.action_event === "speech_bubble_4" || 
                          elem.action_event === "speech_thought" || 
                          elem.action_event === "border_animation" || 
                          elem.action_event === "border_animation_2" || 
                          elem.action_event === "lt_animation_1" || 
                          elem.action_event === "lt_animation_2" || 
                          elem.action_event === "lt_animation_3" || 
                          elem.action_event === "lt_animation_4" || 
                          elem.action_event === "lt_animation_5" || 
                          elem.action_event === "name_animation" || 
                          elem.action_event === "text_animation_1" || 
                          elem.action_event === "text_animation_2") && (
                            <div className="radio_primary"></div>
                          )}
                          {elem.action_end_time ? (
                            <span>{elem.action_time}-{elem.action_end_time}</span>
                          ):(
                            <span>{elem.action_time}</span>
                          )}
                        </div>

                        <div className="cl_va_2 d-flex align-items-center justify-content-between position-relative">
                          <div className="cl_sml_v_a d-flex align-items-center">
                            {elem.action_event === "video_leadgen" && (
                              <i>
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/va_ic_7.png"
                                  }
                                  className="img-fluid"
                                  alt="img"
                                />
                              </i>
                            )}
                            {elem.action_event === "video_cta" && (
                              <i>
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/va_ic_8.png"
                                  }
                                  className="img-fluid"
                                  alt="img"
                                />
                              </i>
                            )}
                            {elem.action_event === "video_meeting" && (
                              <i className="text-primary h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <BsArrowRightSquare />
                              </i>
                            )}

                            {elem.action_event === "video_copypaste" && (
                              <i className="text-danger h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <BsCodeSlash />
                              </i>
                            )}

                            {elem.action_event === "video_annotation" && (
                              <i className="text-info h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <BiEditAlt />
                              </i>
                            )}

                            {elem.action_event === "video_custPoll" && (
                              <i className="text-pink h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <BsQuestionCircle />
                              </i>
                            )}

                            {(elem.action_event === "simple_reveal" || 
                              elem.action_event === "speech_bubble" || 
                              elem.action_event === "speech_bubble_2" || 
                              elem.action_event === "speech_bubble_3" || 
                              elem.action_event === "speech_bubble_4" || 
                              elem.action_event === "speech_thought" || 
                              elem.action_event === "border_animation" || 
                              elem.action_event === "border_animation_2" || 
                              elem.action_event === "lt_animation_1" || 
                              elem.action_event === "lt_animation_2" || 
                              elem.action_event === "lt_animation_3" || 
                              elem.action_event === "lt_animation_4" || 
                              elem.action_event === "lt_animation_5" ||
                              elem.action_event === "name_animation" || 
                              elem.action_event === "text_animation_1" || 
                              elem.action_event === "text_animation_2") && (
                              <i className="text-primary h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <MdRequestPage />
                              </i>
                            )}

                            {elem.action_event === "emoji_content" && (
                              <i className="text-warning h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <BsFillEmojiHeartEyesFill />
                              </i>
                            )}

                            
                            <div className="vtxt">
                              {elem.action_event === "video_leadgen" && (
                                <>
                                  <h6 className="m-0">
                                    {"Trigger Reel Form"} added
                                  </h6>
                                  <p className="m-0">
                                    {leadgenFormData.headline.length > 40 ?  leadgenFormData.headline.slice(0, 40) : leadgenFormData.headline}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_cta" && (
                                <>
                                  <h6 className="m-0">
                                    {"Custom CTA Link"} added
                                  </h6>
                                  <p className="m-0">
                                    {videoCTAData.formtype === "text"
                                      ? videoCTAData.text
                                      : "Image Added"}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_meeting" && (
                                <>
                                  <h6 className="m-0">
                                    {"CTA Link"} added
                                  </h6>
                                  <p className="m-0">
                                    {videoMeetingData.fullname}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_annotation" && (
                                <>
                                  <h6 className="m-0">{"Link Card"} added</h6>
                                  <p className="m-0">
                                    {annotationData.annotationText}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_copypaste" && (
                                <>
                                  <h6 className="m-0">
                                    {"Content Locker Lead Form"} added
                                  </h6>
                                  <p className="m-0">
                                    {copyPasteData.CRMHtmlText.length > 50
                                      ? copyPasteData.CRMHtmlText.substring(
                                          0,
                                          50
                                        )
                                      : copyPasteData.CRMHtmlText}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_custPoll" && (
                                <>
                                  <h6 className="m-0">{"Custom Poll"} added</h6>
                                  <p className="m-0">{custPollData.question}</p>
                                </>
                              )}

                              {elem.action_event === "simple_reveal" && (
                                <>
                                  <h6 className="m-0">{"Simple Reveal"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "speech_bubble" && (
                                <>
                                  <h6 className="m-0">{"Speech Bubble 1"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "speech_bubble_2" && (
                                <>
                                  <h6 className="m-0">{"Speech Bubble 2"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "speech_bubble_3" && (
                                <>
                                  <h6 className="m-0">{"Speech Bubble 3"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "speech_thought" && (
                                <>
                                  <h6 className="m-0">{"Speech Thought "} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "border_animation" && (
                                <>
                                  <h6 className="m-0">{"Border Animation"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "border_animation_2" && (
                                <>
                                  <h6 className="m-0">{"Border Animation 2"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_1" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 1"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_2" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 2"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_3" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 3"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_4" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 4"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_5" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 5"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "name_animation" && (
                                <>
                                  <h6 className="m-0">{"Name Personalization"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "text_animation_1" && (
                                <>
                                  <h6 className="m-0">{"Text Animation 1"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "text_animation_2" && (
                                <>
                                  <h6 className="m-0">{"Text Animation 2"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "emoji_content" && (
                                <>
                                  <h6 className="m-0">{"Emoji Icon"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}
                            </div>
                          </div>

                          <div className="cl_sml_v_b">
                            <button
                              className="bg-transparent border-0"
                              onClick={(e) => {
                                handleEditTrigger(e, elem.action_event,elem.id)
                                elem.action_end_time ? setShowTimingControl(true) : setShowTimingControl(false)
                              }}
                            >
                              <i className="fa fa-pencil"></i>
                              <br />
                              Edit
                            </button>
                            <button
                              className="bg-transparent border-0"
                              onClick={(e) =>
                                handleDeleteTrigger(e, elem.action_event,elem.action_time,elem.id)
                              }
                            >
                              <i className="fa fa-trash"></i>
                              <br />
                              Delete
                            </button>
                          </div>
                        </div>
                      </li>
                    ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

        {showOverlayModal && (
          <>
            <OverlayTemplatesModal
              setShowOverlayModal={setShowOverlayModal}
              handleEffectSetting={handleEffectSetting}
            />
            <div className="modal-backdrop fade show"></div>
          </>
        )}

        {showLowerThirdModal && (
          <>
          <LowerThirdTemplatesModal
            setShowLowerThirdModal={setShowLowerThirdModal}
            handleEffectSetting={handleEffectSetting}
          />
          <div className="modal-backdrop fade show"></div>
        </>
        )}
    </>
  );
};

export default VideoActions;
